{
  "_meta": {
    "_comment": "Phase 6 Wave 2 Task 06 — French (placeholder, falls back to EN for missing keys). vg-binding: PLAN:task-06",
    "locale": "fr",
    "completeness": "placeholder"
  },
  "app": {
    "name": "Printway Merchant"
  },
  "actions": {
    "save": "Enregistrer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "confirm": "Confirmer",
    "back": "Retour",
    "submit": "Envoyer",
    "edit": "Modifier",
    "create": "Créer",
    "search": "Rechercher",
    "filter": "Filtrer",
    "refresh": "Actualiser",
    "loading": "Chargement…",
    "processing": "Traitement…",
    "retry": "Réessayer",
    "logout": "Se déconnecter",
    "login": "Se connecter",
    "copy": "Copier",
    "copied": "Copié",
    "clear": "Effacer",
    "previous": "Précédent",
    "next": "Suivant",
    "close": "Fermer",
    "collapse": "Réduire",
    "confirmDelete": "Supprimer « {{name}} » ? Cette action est irréversible.",
    "continue": "Continuer",
    "dismiss": "Ignorer",
    "done": "Terminé",
    "expand": "Développer",
    "fullscreen": "Activer le plein écran",
    "menu": "Menu",
    "prev": "Précédent",
    "remove": "Supprimer",
    "saveChanges": "Enregistrer les modifications",
    "saved": "Enregistré",
    "saving": "Enregistrement…",
    "select": "Sélectionner…",
    "setDefault": "Définir par défaut",
    "unsetDefault": "Retirer par défaut",
    "upToDate": "À jour",
    "upload": "Téléverser",
    "label": "Actions",
    "enable": "Activer"
  },
  "navigation": {
    "dashboard": "Tableau de bord",
    "stores": "Boutiques",
    "products": "Produits",
    "orders": "Commandes",
    "shipments": "Suivi des expéditions",
    "wallet": "Portefeuille",
    "invoices": "Factures",
    "notifications": "Notifications",
    "support": "Support",
    "tickets": "Tickets",
    "settings": "Paramètres",
    "finance": "Finances",
    "team": "Équipe",
    "members": "Membres",
    "teams": "Équipes",
    "branding": "Identité",
    "sidebar": {
      "catalog": "Catalogue",
      "myProducts": "Mes produits",
      "storeSettings": "Paramètres boutique",
      "syncLogs": "Journaux de sync",
      "billing": "Facturation",
      "profile": "Profil",
      "settingsTeam": "Équipe",
      "settingsNotifications": "Notifications",
      "loginHistory": "Historique de connexion"
    }
  },
  "topbar": {
    "selectLanguage": "Choisir la langue",
    "selectTimezone": "Choisir le fuseau horaire",
    "profile": "Profil",
    "theme": {
      "label": "Thème",
      "light": "Clair",
      "dark": "Sombre",
      "system": "Système"
    },
    "balance": {
      "label": "Solde"
    },
    "outstanding": {
      "label": "Encours",
      "overdueBadge_one": "{{count}} en retard",
      "overdueBadge_other": "{{count}} en retard",
      "overdueBadge": "{{count}} en retard"
    },
    "help": {
      "label": "Aide",
      "support": "Support / Centre d'aide",
      "contact": "Contacter le support",
      "documentation": "Documentation",
      "email": "Écrivez-nous"
    },
    "announcement": {
      "viewDetails": "Voir les détails de l'annonce",
      "dismiss": "Ignorer",
      "previous": "Précédent",
      "next": "Suivant"
    },
    "emailNotVerified": "E-mail non vérifié",
    "emailNotVerifiedAria": "E-mail non vérifié — ouvrez le profil pour renvoyer la vérification",
    "walletBalance": "Portefeuille",
    "walletBalanceAria": "Solde du portefeuille {{label}}",
    "notifications": {
      "title": "Notifications",
      "ariaWithCount": "Notifications ({{count}} non lues)",
      "unreadCount": "{{count}} non lues",
      "loading": "Chargement…",
      "empty": "Aucune notification pour le moment.",
      "viewAll": "Tout afficher",
      "markAllRead": "Tout marquer comme lu",
      "markReadError": "Impossible de marquer comme lu. Veuillez réessayer.",
      "reloadPrompt": "Une nouvelle version est disponible — veuillez actualiser votre navigateur.",
      "forbidden": {
        "title": "Notifications indisponibles",
        "body": "Vous n'avez pas accès à un fil de notifications pour le moment.",
        "retry": "Réessayer"
      }
    },
    "invoices": {
      "overdue": "Factures en retard",
      "dueSoon": "Factures à échéance proche",
      "outstandingAria": "Factures impayées {{label}}"
    },
    "logoAria": "Accueil Printway"
  },
  "banners": {
    "_comment": "Phase 6 Wave 12 Task 42 — Persistent banner copy (suspend + overdue invoice). vg-binding: PLAN:task-42 / P6.D-114 / P6.D-247 / P6.D-248 / G-70 / G-71",
    "suspend": {
      "title": "Compte suspendu",
      "message": "Votre compte est suspendu. Contactez le support administrateur.",
      "contact": "Contacter Support"
    },
    "overdue": {
      "title_one": "{{count}} facture(s) en retard",
      "title_other": "{{count}} facture(s) en retard",
      "cta": "Payer maintenant",
      "dismiss": "Ignorer"
    }
  },
  "mutationGuard": {
    "_comment": "Phase 6 Wave 12 Task 42 — Mutation lockdown copy. vg-binding: PLAN:task-42 / P6.D-114 / P6.D-248",
    "disabled": "Action désactivée — compte suspendu",
    "error": "Action impossible — compte suspendu"
  },
  "suspended": {
    "title": "Compte suspendu",
    "body": "Veuillez contacter le support.",
    "shortLabel": "Suspendu — contactez le support."
  },
  "auth": {
    "_comment": "Phase 6 Wave 12 Task 43 — adds forgotPassword + resetPassword sub-namespaces. vg-binding: PLAN:task-43 / P6.D-184 / P6.D-130",
    "title": "Connectez-vous pour continuer",
    "email": "E-mail",
    "password": "Mot de passe",
    "remember": "Se souvenir de moi",
    "forgot": "Mot de passe oublié ?",
    "submit": "Se connecter",
    "submitting": "Traitement…",
    "twofa": {
      "prompt": "Ouvrez votre application d'authentification et entrez le code à 6 chiffres.",
      "label": "Code d'authentification (TOTP)",
      "submit": "Vérifier"
    },
    "errors": {
      "invalidEmail": "Adresse e-mail invalide.",
      "missingEmail": "Veuillez saisir votre e-mail.",
      "missingPassword": "Veuillez saisir votre mot de passe.",
      "shortPassword": "Le mot de passe doit comporter au moins 8 caractères.",
      "invalidTotp": "Le code TOTP doit comporter 6 chiffres.",
      "invalidCredentials": "E-mail ou mot de passe incorrect.",
      "accountLockedTitle": "Compte temporairement verrouillé.",
      "accountLockedBody": "5 tentatives échouées — réessayez dans {{countdown}} ou réinitialisez votre mot de passe.",
      "rateLimited": "Trop de requêtes. Veuillez réessayer dans un instant.",
      "network": "Impossible de joindre le serveur. Veuillez réessayer."
    },
    "forgotPassword": {
      "title": "Mot de passe oublié",
      "subtitle": "Saisissez votre e-mail — nous vous enverrons un lien de réinitialisation.",
      "email": "E-mail",
      "submit": "Envoyer le lien",
      "backToLogin": "← Retour à la connexion",
      "sentSuccess": {
        "title": "E-mail envoyé (si valide)",
        "message": "Si l'e-mail existe, un lien a été envoyé.",
        "hint": "Vous ne l'avez pas reçu ? Vérifiez votre dossier spam, ou l'adresse e-mail n'est peut-être pas enregistrée — vous pouvez créer un nouveau compte."
      },
      "headingFull": "Mot de passe oublié ?",
      "helperFull": "Saisissez votre adresse e-mail et nous vous enverrons les instructions pour réinitialiser votre mot de passe.",
      "login": "Connexion",
      "remember": "Vous vous souvenez de votre mot de passe ?",
      "submitFull": "Envoyer les instructions de réinitialisation",
      "submittingFull": "Envoi…"
    },
    "resetPassword": {
      "title": "Réinitialiser mot de passe",
      "subtitle": "Saisissez un nouveau mot de passe.",
      "newPassword": "Nouveau mot de passe",
      "confirmPassword": "Confirmer le mot de passe",
      "submit": "Réinitialiser",
      "success": "Mot de passe réinitialisé. Redirection vers la connexion…",
      "tokenInvalid": "Ce lien est expiré ou invalide. Veuillez en demander un nouveau.",
      "requestNew": "→ Demander un nouveau lien"
    },
    "footnote": "Votre session est protégée par un cookie sécurisé.",
    "login": {
      "_comment": "Phase 6 i18n batch M1 — Marketing decor panel on LoginPage right column. vg-binding: P6.D-131 / P6.D-221",
      "marketing": {
        "workspaceBadge": "Espace marchand",
        "ordersTitle": "Commandes du jour",
        "live": "En direct",
        "orders": "Commandes",
        "onTime": "À l'heure",
        "wallet": "Portefeuille",
        "syncQueue": "File de synchronisation",
        "productsReady": "{{count}} produits prêts",
        "billing": "Facturation",
        "billingClear": "Aucun impayé",
        "noOverdue": "Aucune facture en retard"
      },
      "heading": "Bon retour",
      "noAccount": "Nouveau sur Printway ?",
      "submit": "Se connecter",
      "submitting": "Connexion…"
    },
    "register": {
      "_comment": "Phase 6 i18n batch M1 — RegisterPage country select options + existing register sub-keys. vg-binding: P6.D-131 / P6.D-221 / P6.D-253",
      "countries": {
        "VN": "Vietnam (VN)",
        "US": "États-Unis (US)",
        "GB": "Royaume-Uni (GB)",
        "AU": "Australie (AU)",
        "CA": "Canada (CA)",
        "FR": "France (FR)",
        "DE": "Allemagne (DE)"
      },
      "countryLabel": "Pays",
      "email": "E-mail",
      "errors": {
        "emailRequired": "Veuillez saisir un email valide.",
        "passwordTooShort": "Le mot de passe doit comporter au moins 12 caractères.",
        "displayNameRequired": "Veuillez saisir un nom d'affichage.",
        "countryRequired": "Veuillez sélectionner un pays.",
        "acceptTermsRequired": "Vous devez accepter les conditions d'utilisation.",
        "emailTaken": "Cet email est déjà enregistré. Connectez-vous plutôt.",
        "invalid": "Veuillez vérifier vos informations.",
        "rateLimit": "Trop de requêtes. Réessayez dans quelques minutes.",
        "generic": "Échec de l'inscription. Veuillez réessayer.",
        "passwordMismatch": "Les mots de passe ne correspondent pas."
      },
      "title": "Créer un compte",
      "subtitle": "Inscrivez-vous pour vendre des produits en impression à la demande sur Printway.",
      "password": "Mot de passe",
      "displayName": "Nom d'affichage",
      "acceptTerms": "J'accepte les conditions d'utilisation et la politique de confidentialité.",
      "submit": "S'inscrire",
      "alreadyHaveAccount": "Vous avez déjà un compte ?",
      "loginLink": "Se connecter",
      "passwordHint": "(12 caractères minimum)",
      "confirmPassword": "Confirmer le mot de passe"
    },
    "emailPlaceholder": "your@email.com",
    "marketing": {
      "subtitle": "Rejoignez des milliers d'entrepreneurs qui vendent des produits personnalisés avec Printway",
      "title": "Lancez votre activité POD dès aujourd'hui"
    },
    "or": "OU",
    "registerCta": "S'inscrire",
    "sso": {
      "google": "Continuer avec Google",
      "lark": "Continuer avec Lark Suite"
    },
    "verifyEmail": {
      "errors": {
        "invalid": "Code OTP incorrect. Veuillez réessayer.",
        "expired": "Code OTP expiré. Cliquez sur « Renvoyer » pour en recevoir un nouveau.",
        "rateLimit": "Trop de tentatives. Veuillez patienter.",
        "generic": "Échec de la vérification. Veuillez réessayer.",
        "resendRateLimit": "Veuillez patienter avant de renvoyer.",
        "resendGeneric": "Échec du renvoi de l'OTP. Réessayez plus tard."
      },
      "resendSuccess": "Code OTP renvoyé. Veuillez vérifier votre email.",
      "missingEmailTitle": "Aucun email à vérifier",
      "missingEmailBody": "Veuillez retourner à la page d'inscription.",
      "backToRegister": "← S'inscrire",
      "title": "Vérifier l'email",
      "subtitle": "Nous avons envoyé un code à 6 chiffres à :",
      "otpLabel": "Code OTP à 6 chiffres",
      "submit": "Vérifier",
      "didNotReceive": "Vous n'avez pas reçu le code ?",
      "resend": "Renvoyer",
      "backToLogin": "← Se connecter",
      "resendCooldown": "Renvoyer ({{n}}s)"
    }
  },
  "currency": {
    "tooltip": "Source : USD. Taux : {{rate}} {{display}}/USD @ {{fetchedAt}}.",
    "fallback": "Affichage USD — taux indisponible."
  },
  "datetime": {
    "justNow": "À l'instant",
    "secondsAgo": "il y a {{count}} secondes",
    "minutesAgo": "il y a {{count}} minutes",
    "hoursAgo": "il y a {{count}} heures",
    "daysAgo": "il y a {{count}} jours",
    "yesterday": "Hier",
    "tomorrow": "Demain",
    "in": "{{value}}"
  },
  "errors": {
    "403": {
      "code": "403",
      "title": "Accès refusé",
      "subtitle": "Votre compte n'a pas accès à cette page. Contactez un administrateur si vous pensez qu'il s'agit d'une erreur.",
      "contactAdmin": "Contacter l'admin"
    },
    "404": {
      "code": "404",
      "title": "Page introuvable",
      "subtitle": "La page demandée n'existe pas ou a été déplacée.",
      "backHome": "Retour à l'accueil"
    },
    "500": {
      "code": "500",
      "title": "Le serveur rencontre un problème",
      "subtitle": "Votre requête n'a pas abouti. Veuillez réessayer.",
      "retry": "Réessayer",
      "statusPage": "Page de statut"
    },
    "_comment": "Phase 6 Wave 12 Task 43 — adds 404/403/500 dedicated error-page copy. vg-binding: PLAN:task-43 / P6.D-204",
    "generic": "Une erreur s'est produite. Veuillez réessayer.",
    "network": "Connexion perdue — vérifiez votre réseau.",
    "unauthorized": "Votre session a expiré. Reconnectez-vous.",
    "forbidden": "Vous n'avez pas la permission.",
    "validation": "Données invalides. Vérifiez les champs en rouge.",
    "rate_limited": "Trop de requêtes — réessayez bientôt.",
    "server": "Serveur indisponible. Réessayez plus tard.",
    "fx_provider_unavailable": "Taux indisponible. Affichage en USD.",
    "maintenance": {
      "title": "En maintenance",
      "subtitle": "La plateforme est en maintenance. Veuillez réessayer dans quelques minutes.",
      "retry": "Réessayer"
    }
  },
  "promo": {
    "_comment": "Phase 6 Wave 12 Task 43 — Promo banner copy (P6.D-222). vg-binding: PLAN:task-43 / P6.D-222 / G-72",
    "dismiss": "Fermer",
    "cta": "En savoir plus"
  },
  "security": {
    "_comment": "Phase 6 Wave 12 Task 43 — Suspend overlay copy (P6.D-114). vg-binding: PLAN:task-43 / P6.D-114",
    "suspend": {
      "overlay": {
        "title": "Compte suspendu",
        "body": "Accès restreint. Contactez le support administrateur.",
        "cta": "Contacter Support"
      }
    }
  },
  "artwork": {
    "nav": {
      "label": "Bibliothèque d'artwork"
    },
    "empty": "Aucun fichier dans ce dossier.",
    "folder": {
      "new": "+ Nouveau dossier",
      "root": "Tous les artworks",
      "collapse": "Réduire",
      "expand": "Développer"
    },
    "view": {
      "grid": "Grille",
      "list": "Liste",
      "listAria": "Vue liste",
      "gridAria": "Vue grille"
    },
    "list": {
      "colThumb": "Aperçu",
      "colName": "Nom",
      "colSize": "Taille",
      "colUploaded": "Importé",
      "colUsed": "Utilisé"
    },
    "upload": {
      "trigger": "Téléverser",
      "dropHere": "Déposez les fichiers ici ou cliquez pour parcourir",
      "browse": "Cliquez pour parcourir",
      "maxSizeSync": "Synchrone ≤10Mo",
      "async": "Asynchrone >10Mo",
      "maxFiles": "Téléversez au maximum {{max}} images à la fois.",
      "tooLarge": "L'image dépasse 100 Mo."
    },
    "bulk": {
      "selectedCount": "{{count}} sélectionné(s)",
      "move": "Déplacer",
      "delete": "Supprimer",
      "downloadZip": "Télécharger ZIP",
      "deleteError": "Impossible de supprimer l'artwork. Veuillez réessayer.",
      "deleteSuccess": "{{count}} artwork supprimé(s).",
      "moveError": "Impossible de déplacer l'artwork. Veuillez réessayer.",
      "moveSuccess": "{{count}} artwork déplacé(s) vers {{folder}}.",
      "needSelection": "Sélectionnez d'abord un artwork (cochez la case en haut à gauche de la carte).",
      "deleteSuccess_one": "{{count}} visuel supprimé.",
      "deleteSuccess_other": "{{count}} visuels supprimés.",
      "moveSuccess_one": "{{count}} visuel déplacé vers {{folder}}.",
      "moveSuccess_other": "{{count}} visuels déplacés vers {{folder}}."
    },
    "lightbox": {
      "metadata": "Métadonnées",
      "dpi": "DPI",
      "dimensions": "Dimensions",
      "format": "Format",
      "size": "Taille",
      "uploaded": "Importé",
      "usedIn": "Utilisé dans des produits",
      "usedInEmpty": "Pas encore utilisé.",
      "download": "Télécharger",
      "edit": "Modifier",
      "rename": "Renommer",
      "move": "Déplacer",
      "delete": "Supprimer",
      "prev": "Précédent",
      "next": "Suivant",
      "zoomIn": "Zoom +",
      "zoomOut": "Zoom -",
      "rootFolder": "(racine)",
      "ok": "OK"
    },
    "editor": {
      "title": "Modifier l'artwork",
      "crop": "Recadrer",
      "rotate": "Rotation",
      "resize": "Redimensionner",
      "reset": "Réinitialiser",
      "save": "Enregistrer",
      "saving": "Enregistrement...",
      "savedToast": "Enregistré comme nouvel artwork",
      "saveErrorToast": "Échec de l'enregistrement",
      "cropHint": "Glisser pour sélectionner",
      "widthLabel": "Largeur (px)",
      "heightLabel": "Hauteur (px)",
      "mockupOverlayNote": "Aperçu maquette statique — positionnement interactif dans Éditeur avancé (à venir)"
    },
    "badge": {
      "embroidery": "Broderie",
      "new": "NOUVEAU",
      "usedIn": "Utilisé {{count}}"
    },
    "quota": {
      "label": "Utilisé : {{used}} / {{limit}}",
      "warn80": "Stockage au-delà de 80%. Nettoyez d'anciens fichiers.",
      "warn90": "Stockage au-delà de 90%. Presque plein !",
      "blocked": "Stockage plein. Les téléversements sont désactivés."
    },
    "mapping": {
      "suggest": "Associer à la commande #{{orderNumber}} ?"
    },
    "grid": {
      "selectAria": "Sélectionner {{name}}"
    },
    "folderPicker": {
      "count": "{{shown}} / {{total}} dossier",
      "title": "Déplacer {{count}} artwork vers un dossier",
      "subtitle": "Choisissez un dossier de destination, ou Root pour le retirer de tout dossier.",
      "search": "Rechercher un dossier par nom…",
      "noMatch": "Aucun dossier correspondant.",
      "empty": "Aucun dossier pour l'instant — créez-en un dans la barre latérale.",
      "hint": "Astuce : double-cliquez pour sélectionner rapidement.",
      "confirm": "Déplacer ici",
      "title_one": "Déplacer {{count}} visuel vers un dossier",
      "title_other": "Déplacer {{count}} visuels vers un dossier"
    },
    "batch": {
      "error": "Lot de téléversement introuvable.",
      "progress": "{{succeeded}}/{{total}} terminés · {{failed}} en échec",
      "fileError": "Fichier non valide.",
      "title": "Lot d'envoi ({{count}} fichiers)",
      "title_one": "Lot de téléversement ({{count}} fichier)",
      "title_other": "Lot de téléversement ({{count}} fichiers)"
    },
    "move": {
      "error": "Impossible de déplacer l'artwork. Veuillez réessayer.",
      "success": "Artwork déplacé vers {{folder}}"
    }
  },
  "orders": {
    "_comment": "Phase 6 Wave 6 Task 17 — Orders list page copy. vg-binding: PLAN:task-17 / P6.D-40 / P6.D-41 / P6.D-42 / P6.D-43 / P6.D-47 / P6.D-48",
    "artwork": {
      "_comment": "Phase 4.9 Wave 5 Task 14 — order-import artwork-ingest copy. vg-binding: PLAN:task-14 / P4.9.D-18 / P4.9.D-19 / P4.9.D-20",
      "section": {
        "title": "Traitement des visuels"
      },
      "aggregate": {
        "processing": "Traitement des visuels",
        "ready": "Visuels prêts",
        "error": "Erreur de visuel"
      },
      "status": {
        "pending": "En attente",
        "downloading": "Téléchargement",
        "validating": "Validation",
        "retrying": "Nouvel essai",
        "validated": "Validé",
        "error": "Erreur"
      },
      "action": {
        "editLink": "Modifier le lien",
        "reIngest": "Retélécharger",
        "manualUpload": "Importer manuellement",
        "unauthorized": "Veuillez vous reconnecter pour continuer.",
        "forbidden": "Vous n'avez pas l'autorisation d'agir sur cette commande."
      },
      "error": {
        "GENERIC": "Le visuel n'a pas pu être traité.",
        "ARTWORK_LINK_UNREACHABLE": "Le lien du visuel est inaccessible. Vérifiez l'URL et les accès.",
        "ARTWORK_FILE_TOO_LARGE": "Le fichier du visuel est trop volumineux.",
        "ARTWORK_EXTENSION_INVALID": "Le type de fichier du visuel n'est pas pris en charge.",
        "ARTWORK_DIMENSION_MISMATCH": "Les dimensions du visuel ne correspondent pas à la zone d'impression.",
        "ARTWORK_DPI_TOO_LOW": "La résolution (DPI) du visuel est trop faible pour l'impression.",
        "ARTWORK_DECODE_FAILED": "Le fichier du visuel n'a pas pu être décodé.",
        "ARTWORK_SSRF_REJECTED": "Le lien du visuel pointe vers une adresse bloquée.",
        "ARTWORK_TEMPLATE_MISSING": "Le gabarit d'impression de cette zone est manquant.",
        "ARTWORK_SYSTEM_ERROR": "Une erreur inattendue est survenue lors du traitement du visuel."
      },
      "thumb": {
        "alt": "Miniature du visuel",
        "openPreview": "Ouvrir l'aperçu"
      },
      "preview": {
        "alt": "Aperçu du visuel"
      },
      "polling": {
        "timeout": "Revenez plus tard — actualiser"
      },
      "editLink": {
        "title": "Mettre à jour le lien du visuel",
        "body": "Collez un nouveau lien public pour cette zone d'impression. Nous le retéléchargerons et le validerons.",
        "label": "Lien du visuel",
        "submit": "Mettre à jour & retélécharger",
        "saving": "Enregistrement…"
      },
      "link": {
        "updated": "Lien mis à jour et retéléchargement mis en file d'attente."
      },
      "reingest": {
        "queued": "Retéléchargement mis en file d'attente."
      },
      "upload": {
        "queued": "Visuel importé et revalidation mise en file d'attente."
      },
      "filter": {
        "label": "Statut du visuel",
        "activeLabel": "Filtré par statut de visuel :"
      },
      "original": {
        "alt": "Visuel original",
        "badge": "Original"
      },
      "requiredSpecs": "Requis : ",
      "actualSpecs": "Réel : ",
      "requiredVsActual": "requis {{required}} · réel : {{actual}}"
    },
    "create": {
      "_comment": "Phase 6 Wave 6 Task 19 — Order Create Wizard copy. vg-binding: PLAN:task-19 / P6.D-52..58 / P6.D-60 / P6.D-61 / G-34",
      "title": "Créer une commande",
      "type": {
        "basic": "Basique",
        "sample": "Échantillon",
        "bulk": "En gros"
      },
      "bulkType": {
        "fba": "FBA",
        "fbt": "FBT",
        "general": "Général"
      },
      "step": {
        "products": "Produits",
        "design": "Créer le design",
        "checkout": "Paiement"
      },
      "context": {
        "store": {
          "label": "Boutique",
          "placeholder": "Choisir une boutique…",
          "auto": "Sélection auto",
          "locked": "Boutique fixée en modification/recommande",
          "changeTitle": "Changer de boutique ?",
          "changeBody": "Changer de boutique vide le panier — les produits appartiennent à la boutique choisie.",
          "changeConfirm": "Changer"
        },
        "type": {
          "label": "Type de commande",
          "basic": "Standard",
          "sample": "Échantillon",
          "bulk": "En gros"
        },
        "bulkType": {
          "label": "Type de gros"
        },
        "gate": {
          "store": "Choisissez une boutique pour continuer",
          "sampleReason": "Choisissez un motif d'échantillon pour continuer",
          "bulkType": "Choisissez un type de gros pour continuer"
        }
      },
      "products": {
        "selectProducts": "Sélectionner des produits",
        "modal": {
          "title": "Sélectionner des produits",
          "searchPlaceholder": "Rechercher des produits…",
          "category": "Catégorie",
          "collection": "Collection",
          "location": "Lieu de production",
          "allCategories": "Toutes les catégories",
          "allCollections": "Toutes les collections",
          "allLocations": "Tous les lieux",
          "loading": "Chargement…",
          "loadError": "Impossible de charger les produits. Veuillez réessayer.",
          "noResults": "Aucun produit ne correspond à ces filtres.",
          "fromPrice": "À partir de {{price}}",
          "variantCount": "{{count}} variantes",
          "selectedCount": "{{count}} produits sélectionnés",
          "selectHint": "Sélectionnez au moins un produit pour continuer.",
          "cancel": "Annuler",
          "startOrder": "Démarrer la commande",
          "filterUnavailable": "Indisponible",
          "filtersError": "Certains filtres n’ont pas pu être chargés. La navigation et la recherche fonctionnent toujours.",
          "search": "Rechercher",
          "tabs": {
            "myProducts": "Mes produits",
            "catalog": "Catalogue"
          },
          "myProducts": {
            "empty": "Aucun de vos produits ne correspond à ces filtres.",
            "browseCatalog": "Parcourir le catalogue",
            "locked": "Plus disponible à la commande",
            "noBlueprint": "Produit de base plus disponible",
            "droppedUnavailable_one": "{{count}} produit sélectionné ne peut plus être commandé et a été retiré.",
            "droppedUnavailable_other": "{{count}} produits sélectionnés ne peuvent plus être commandés et ont été retirés."
          }
        },
        "page": {
          "title": "Créer une commande",
          "subtitle": "Finalisez les options d'expédition et envoyez les détails de livraison de votre client",
          "store": "Boutique",
          "storePlaceholder": "Sélectionner une boutique…",
          "storeLoading": "Chargement des boutiques…",
          "storeChangeTitle": "Changer de boutique ?",
          "storeChangeBody": "Changer de boutique supprime les produits déjà ajoutés à cette commande.",
          "addProduct": "Ajouter un produit",
          "shipping": "Expédition",
          "pay": "Payer",
          "orderName": "Nom de la commande",
          "orderNamePlaceholder": "ORD-2024-001"
        },
        "cart": {
          "empty": "Aucun produit dans cette commande pour l'instant."
        },
        "line": {
          "location": "Emplacement",
          "qty": "Qté",
          "itemCost": "Prix unitaire",
          "total": "Total",
          "note": "Note",
          "notePlaceholder": "Ajoutez des instructions de livraison ici...",
          "loadingVariants": "Chargement des variantes…",
          "noLocation": "Aucun emplacement disponible",
          "variantsError": "Impossible de charger les variantes de ce produit.",
          "variantUnavailable": "Cette combinaison n'est pas disponible — choisissez d'autres options pour continuer.",
          "noPrintAreas": "Ce produit n'a aucune zone d'impression configurée.",
          "myProductUnavailable": "Ce produit ne peut plus être commandé. Retirez-le pour continuer.",
          "myProductLoadError": "Impossible de charger ce produit.",
          "retry": "Réessayer",
          "artworkDetached_one": "{{count}} fichier d'illustration ne correspond pas aux zones d'impression de cette variante et a été retiré de la ligne. Il reste dans votre bibliothèque.",
          "artworkDetached_other": "{{count}} fichiers d'illustration ne correspondent pas aux zones d'impression de cette variante et ont été retirés de la ligne. Ils restent dans votre bibliothèque."
        },
        "artwork": {
          "uploaded": "Visuel ajouté",
          "uploadFailed": "Échec du téléversement",
          "rejected": "Fichier refusé"
        },
        "subtotal": "Sous-total"
      },
      "artwork": {
        "assign": {
          "fromLibrary": "Depuis la bibliothèque",
          "upload": "Téléverser",
          "remove": "Retirer"
        },
        "assigned": "Assigné",
        "unassigned": "Non assigné",
        "incomplete": "L'artwork doit être assigné à toutes les zones d'impression requises",
        "libraryPicker": {
          "title": "Choisir un artwork dans la bibliothèque",
          "search": "Rechercher par nom…",
          "empty": "La bibliothèque est vide. Téléversez un artwork sur /artwork ou utilisez le bouton « Upload new ».",
          "noMatch": "Aucun artwork correspondant.",
          "confirm": "Sélectionner"
        },
        "required": "Requis",
        "optional": "Facultatif",
        "choose": {
          "title": "Choisir un visuel",
          "uploadTitle": "Cliquez ou glissez un fichier dans cette zone pour l'importer",
          "search": "Rechercher par nom de visuel",
          "empty": "Aucun visuel pour l'instant — importez-en un ci-dessus.",
          "noMatch": "Aucun visuel ne correspond à ce nom.",
          "listError": "Impossible de charger votre bibliothèque de visuels.",
          "wrongSize": "{{actual}} ≠ requis {{required}}",
          "apply": "Appliquer à {{area}}"
        }
      },
      "shipping": {
        "field": {
          "name": "Nom complet",
          "line1": "Adresse 1",
          "line2": "Adresse 2 (facultatif)",
          "city": "Ville",
          "state": "État / Province",
          "postalCode": "Code postal",
          "country": "Pays",
          "phone": "Numéro de téléphone",
          "email": "E-mail",
          "line2Placeholder": "Appartement, bureau, unité...",
          "taxNumber": "Numéro fiscal",
          "note": "Note",
          "notePlaceholder": "Ajoutez des instructions de livraison ici..."
        },
        "validate": {
          "button": "Valider",
          "valid": "Valide",
          "warn": "Avertissement",
          "invalid": "Invalide"
        },
        "suggestion": {
          "apply": "Appliquer la suggestion"
        },
        "gps": {
          "button": "Position actuelle"
        },
        "fba": {
          "warehouse": "Entrepôt FBA",
          "fnsku": "FNSKU"
        },
        "search": {
          "country": "Rechercher un pays…",
          "state": "Rechercher état/province…",
          "city": "Rechercher une ville…"
        },
        "state": {
          "none": "Pas d’état/province"
        },
        "method": {
          "label": "Méthode d'expédition",
          "merchant": "Expédié par le marchand",
          "merchantDesc": "Le marchand expédie — saisissez l'adresse de livraison.",
          "tiktok": "Étiquette TikTok (fournie par l'acheteur)",
          "tiktokDesc": "Téléversez l'étiquette fournie — aucune adresse requise.",
          "loading": "Chargement des modes de livraison…",
          "none": "Saisissez une adresse de livraison pour voir les options disponibles.",
          "sampleFree": "Les commandes échantillon sont livrées gratuitement — aucuns frais de port."
        },
        "label": {
          "title": "Téléverser l'étiquette d'expédition",
          "help": "PDF ou image. L'étiquette contient déjà les infos du destinataire, aucune adresse requise.",
          "modeUpload": "Téléverser un fichier",
          "modeLink": "Saisir le lien",
          "missingUpload": "Choisissez un fichier étiquette pour continuer.",
          "missingLink": "Collez un lien vers l’étiquette pour continuer."
        },
        "country": "Pays",
        "line1": "Adresse ligne 1",
        "line2": "Adresse ligne 2 (facultatif)",
        "phone": "Téléphone",
        "postal": "Code postal",
        "rate": {
          "calculating": "Calcul des tarifs…",
          "eta": "{{min}}–{{max}} jours ouvrés",
          "title": "Tarif d'expédition",
          "fillAddress": "Saisissez l'adresse complète (ligne 1, ville, pays) pour voir les méthodes et tarifs d'expédition."
        },
        "recipient": "Nom du destinataire",
        "infoTitle": "Informations de livraison",
        "methodTitle": "Mode de livraison",
        "sampleCountryLocked": "Les commandes échantillons sont expédiées vers notre site au Vietnam."
      },
      "review": {
        "subtotal": "Sous-total",
        "shipping": "Expédition",
        "tax": "Taxe",
        "embroideryCost": "Broderie",
        "total": "Total",
        "title": "Vérifier la commande",
        "table": {
          "product": "Produit",
          "variant": "Variante",
          "qty": "Qté",
          "artwork": "Design",
          "subtotal": "Sous-total"
        },
        "embroidery": {
          "title": "Options de broderie",
          "threadColor": "Couleur du fil",
          "position": "Position",
          "digitizingFee": "Frais de digitalisation"
        },
        "continueToPayment": "Continuer au paiement",
        "customer": "Client",
        "itemsTitle": "Articles de la commande ({{count}})",
        "noCustomer": "Aucune info client",
        "qtyLine": "Qté : {{qty}} × {{price}}",
        "saveOnly": "Enregistrer la commande (payer plus tard)",
        "shippingAddress": "Adresse de livraison",
        "summaryTitle": "Récapitulatif de la commande",
        "taxPct": "Taxe ({{pct}})",
        "tiktokAddress": "Étiquette marketplace (sans adresse)",
        "artworkChecking": "Vérification des exigences d'artwork…",
        "artworkRequired": "Un artwork est requis pour ces zones d'impression : {{areas}}. Revenez à l'étape Artwork pour terminer."
      },
      "nav": {
        "next": "Suivant",
        "back": "Retour",
        "save_draft": "Enregistrer brouillon"
      },
      "orderType": {
        "sampleReason": {
          "label": "Motif de l'échantillon (requis)",
          "quality": "Contrôle qualité",
          "colorMatch": "Correspondance couleur",
          "proofApproval": "Validation BAT",
          "marketing": "Photos marketing",
          "other": "Autre"
        }
      },
      "orderName": {
        "label": "Nom de la commande",
        "uniqueHint": "doit être unique — pas de doublon",
        "placeholder": "ex. PO-2025-001 / lot Jean 1",
        "help": "Obligatoire — sert de référence interne (numéro PO, nom du client…). Un nom unique par commande."
      },
      "design": {
        "skipHint": "Créez ou ajustez le visuel ici, ou passez — vous pourrez téléverser par zone d'impression à l'étape Artwork.",
        "badge": {
          "newProduct": "Nouveau produit — visuel requis",
          "personalized": "Personnalisé — nouveau visuel requis",
          "fromProduct": "Visuel issu du produit"
        },
        "noMockup": "Aucun aperçu de mockup disponible",
        "editBtn": "Modifier",
        "editor": {
          "title": "Design Maker",
          "noArtwork": "Aucun visuel sélectionné"
        }
      },
      "confirm": {
        "title": "Confirmation de commande",
        "discount": "Code de réduction",
        "discountPlaceholder": "Saisir un code",
        "discountSoon": "Les codes de réduction ne sont pas encore disponibles.",
        "apply": "Appliquer",
        "summary": "Récapitulatif",
        "subtotal": "Sous-total ({{count}} articles)",
        "shippingFee": "Frais de livraison",
        "taxFee": "Taxes",
        "surcharge": "Total des suppléments",
        "surchargeSoon": "Les suppléments ne sont pas encore détaillés.",
        "total": "Total",
        "paymentMethod": "Moyen de paiement",
        "payLater": "Payer plus tard",
        "payLaterHint": "Créez la commande maintenant et payez depuis sa page.",
        "wallet": "Portefeuille Printway",
        "credit": "Crédit Printway",
        "balance": "Solde : {{balance}}",
        "walletShort": "Solde : {{balance}} — insuffisant",
        "creditSoon": "pas encore disponible",
        "terms": "J'accepte les conditions générales",
        "submit": "Créer la commande",
        "submitting": "Création…",
        "blocked": "Le prix n'est pas encore prêt. Veuillez patienter.",
        "failed": "Impossible de créer la commande. Veuillez réessayer.",
        "paidTitle": "Commande confirmée",
        "draftTitle": "Commande créée",
        "draftBody": "Vous pouvez la payer à tout moment depuis sa page.",
        "termsPrefix": "J'accepte les",
        "termsLink": "Conditions générales"
      },
      "validation": {
        "required": "Ce champ est obligatoire",
        "emailInvalid": "Saisissez une adresse e-mail valide",
        "phoneInvalid": "Saisissez un numéro de téléphone valide",
        "storeRequired": "Sélectionnez la boutique de cette commande",
        "noLines": "Ajoutez au moins un produit",
        "unresolvedVariant": "Chaque produit doit avoir une variante sélectionnée",
        "artworkRequired": "Importez un visuel pour chaque zone d’impression requise",
        "artworkAreasMissing": "Importez un visuel pour : {{areas}}",
        "methodRequired": "Choisissez un mode de livraison",
        "orderNameRequired": "Saisissez un nom pour cette commande",
        "productUnavailable": "Un produit ne peut pas être confirmé à la commande — réessayez ou retirez-le",
        "productLoading": "Vérification de vos produits — réessayez dans un instant"
      }
    },
    "import": {
      "_comment": "Phase 6 Wave 6 Task 20 — Excel Import wizard copy. vg-binding: PLAN:task-20 / P6.D-62 / P6.D-63 / G-35",
      "navLabel": "Import Excel",
      "title": "Import Excel",
      "step": {
        "upload": "Téléverser",
        "matching": "Mappage",
        "review": "Vérifier",
        "payment": "Paiement",
        "result": "Résultat",
        "aria": "Étapes d'import",
        "downloadFailed": "Échec du téléchargement",
        "uploadFailed": "Échec du téléversement",
        "presetLoadFailed": "Échec du chargement du préréglage",
        "saveFailed": "Échec de l'enregistrement",
        "quoteFailed": "Échec du devis",
        "commitFailed": "Échec de la validation"
      },
      "upload": {
        "dropHere": "Déposez XLSX/CSV...",
        "templateDownload": "Télécharger modèle",
        "button": "Téléverser",
        "uploading": "Téléversement...",
        "invalidType": "Type de fichier non supporté",
        "xlsxNote": "Aperçu après traitement serveur"
      },
      "matching": {
        "title": "Mapper colonnes",
        "preset": {
          "label": "Préréglage",
          "save": "Enregistrer préréglage",
          "namePrompt": "Nom du préréglage :"
        },
        "col": {
          "field": "Champ Printway",
          "column": "Colonne du fichier"
        },
        "field": {
          "orderNumber": "Numéro de commande",
          "customerName": "Nom du client",
          "customerEmail": "Email du client",
          "addressLine1": "Adresse ligne 1",
          "city": "Ville",
          "state": "État / Province",
          "postalCode": "Code postal",
          "country": "Pays",
          "productSku": "SKU produit",
          "qty": "Quantité",
          "artworkUrl_print_area_1": "URL design — zone 1",
          "artworkUrl_print_area_2": "URL design — zone 2",
          "embroidery_thread_color": "Couleur de fil"
        }
      },
      "review": {
        "errorsOnly": "Erreurs seulement",
        "empty": "Aucune ligne à afficher",
        "totals": {
          "orders": "Total commandes",
          "errors": "Erreurs",
          "estimated": "Total estimé",
          "grouped": "{{rows}} lignes → {{orders}} commandes (groupées par order_name)"
        }
      },
      "payment": {
        "method": {
          "wallet": "Portefeuille",
          "cc": "Carte de crédit",
          "paypal": "PayPal",
          "payLater": "Payer plus tard"
        },
        "batchNote": "Une seule transaction pour tout le lot",
        "commit": "Confirmer le lot",
        "committing": "Confirmation...",
        "payLaterNote": "Les commandes seront créées comme brouillons impayés — payez chaque commande plus tard depuis la liste des commandes."
      },
      "result": {
        "success": "Réussi : {{count}}",
        "failed": "Échoué : {{count}}",
        "errorsDownload": "Télécharger CSV erreurs",
        "orderIds": "Commandes créées",
        "restart": "Importer un autre lot"
      },
      "progress": {
        "percent": "{{pct}}% — {{processed}}/{{total}} commandes"
      },
      "nav": {
        "next": "Suivant",
        "back": "Retour"
      },
      "action": "Importer"
    },
    "nav": {
      "label": "Commandes"
    },
    "list": {
      "title": "Commandes",
      "emptyState": {
        "noMatchFilter": "Aucune commande ne correspond au filtre actuel."
      },
      "error": {
        "loadFailed": "Échec du chargement des commandes"
      },
      "dateRange": {
        "last7": "7 derniers jours",
        "last30": "30 derniers jours",
        "last90": "90 derniers jours",
        "allTime": "Toute la période",
        "from": "Du",
        "to": "Au",
        "done": "Terminé"
      },
      "bulkDiscount": {
        "itemsOrdered": "Articles commandés",
        "itemsThreshold": "10+ articles",
        "shipping": "Remise sur la livraison",
        "shippingValue": "Jusqu'à 10 %",
        "product": "Remise sur le produit",
        "productValue": "Jusqu'à 5 %"
      },
      "store": {
        "manual": "Commande manuelle",
        "all": "Toutes les boutiques",
        "search": "Rechercher une boutique…"
      },
      "cancelConfirm_one": "Annuler {{count}} commande(s) ?",
      "cancelConfirm_other": "Annuler {{count}} commande(s) ?",
      "createOrder": "Créer une commande",
      "createTicket": "Créer un ticket",
      "sound": {
        "on": "Son nouvelle commande : activé",
        "off": "Son nouvelle commande : désactivé"
      },
      "dateRangePicker": "Plage de dates",
      "paymentFilter": "Statut de paiement",
      "productFilter": {
        "empty": "Aucun produit trouvé",
        "label": "Type de produit",
        "selected": "Produit",
        "search": "Rechercher des produits"
      },
      "statusFilter": "Statut",
      "storeFilter": "Boutique",
      "tabsLabel": "Statut de la commande",
      "cancelConfirm": "Annuler {{count}} commandes ?",
      "sendToProduction": {
        "cta": "Envoyer en production",
        "sending": "Envoi…",
        "success": "Commande envoyée en production.",
        "tooltipSend": "Envoyer cette commande au fournisseur pour démarrer la production.",
        "tooltipNotWaiting": "Seules les commandes payées en attente d'approbation peuvent être envoyées en production."
      },
      "bulkSend": {
        "success": "{{assigned}} envoyée(s) en production, {{blocked}} bloquée(s).",
        "error": "Échec de l'envoi groupé. Veuillez réessayer."
      },
      "bulkSendResult": {
        "title": "Résultats de l'envoi en production",
        "summary": "{{assigned}} envoyée(s) · {{blocked}} bloquée(s) · {{total}} au total",
        "assigned": "Envoyée en production",
        "blocked": "Bloquée",
        "itemsAssigned": "{{count}} article(s) assigné(s)",
        "close": "Fermer",
        "orderLabel": "Commande {{id}}",
        "reason": {
          "ARTWORK_NOT_VALIDATED": "Illustration non validée",
          "FORBIDDEN_TENANT": "Non autorisé",
          "INVALID_STATE": "État non éligible à l'envoi",
          "NOT_FOUND": "Commande introuvable",
          "unknown": "Bloquée"
        }
      },
      "shippingNameSearch": "Livré à",
      "moreFilters": "Plus de filtres",
      "sourceTabsLabel": "Source de la commande",
      "sourceTab": {
        "my": "Mes commandes",
        "external": "Commandes externes"
      },
      "orderSearch": "ID",
      "dateFrom": "Depuis {{date}}",
      "dateUntil": "Jusqu'au {{date}}",
      "filter": {
        "statusAll": "Statut : tous",
        "clearHint": "Cliquez à nouveau pour effacer"
      },
      "shippingStatusFilter": "Statut de livraison",
      "shipping": {
        "merchant": "Marchand",
        "tiktokLabel": "Étiquette TikTok"
      },
      "creationTypeFilter": "Type de création",
      "creation": {
        "merchant": "Tableau de bord marchand",
        "admin": "Admin",
        "api": "API",
        "other": "Autre"
      }
    },
    "tab": {
      "all": "Tous",
      "draft": "Brouillon",
      "pending": "En attente",
      "processing": "En traitement",
      "shipped": "Expédié",
      "delivered": "Livré",
      "issues": "Problèmes",
      "unverified": "Non vérifiée",
      "waiting": "En attente d'approbation",
      "late": "En retard"
    },
    "search": {
      "placeholder": "Rechercher par n° de commande, nom, client, e-mail…",
      "recent": "Récent"
    },
    "bulk": {
      "_comment": "Phase 6 Wave 6 Task 21 — clés étendues pour la popup d'actions en masse.",
      "selectedCount": "{{count}} sélectionné(s)",
      "cancel": "Annuler les commandes",
      "export": "Exporter CSV",
      "maxWarn": "Maximum 200 commandes par action en masse",
      "title": "Actions en masse",
      "actionLabel": "Action",
      "tagLabel": "Valeur du tag",
      "tagRequired": "Saisissez une valeur de tag",
      "moreActions": "Plus d'actions",
      "maxLabel": "{{n}} sélectionnés (max 200)",
      "partialToast": "{{ok}}/{{total}} réussis, {{fail}} échoués",
      "action": {
        "cancel": "Annuler",
        "export": "Exporter",
        "retag": "Re-tagger",
        "markShipped": "Marquer expédiée",
        "retrigger": "Relancer"
      },
      "confirm": {
        "cancel": "Annuler {{n}} commande(s) ?",
        "export": "Exporter {{n}} commande(s) en CSV ?",
        "retag": "Appliquer le tag à {{n}} commande(s) ?",
        "markshipped": "Marquer {{n}} commande(s) comme expédiées ?",
        "retrigger": "Relancer le fulfilment pour {{n}} commande(s) ?"
      },
      "actionFailed": "Échec de l'action groupée",
      "pay": {
        "confirmBody": "{{count}} commande(s) — {{amount}} au total. Choisissez le mode de paiement ci-dessous.",
        "confirmCta": "Confirmer le paiement",
        "confirmTitle": "Payer les commandes sélectionnées ?",
        "cta": "Payer",
        "genericError": "Échec du paiement",
        "maxCap": "Maximum {{n}} commandes par paiement.",
        "onlyUnpaid": "Seules les commandes impayées peuvent être payées — désélectionnez les autres.",
        "processing": "Paiement…",
        "resultFailedHeading": "Échec du paiement ({{n}}) :",
        "resultPaidList": "Payées : {{list}}",
        "singleCurrency": "Sélectionnez des commandes d'une seule devise pour les payer ensemble.",
        "funding": {
          "label": "Payer avec",
          "creditInsufficient": "Crédit insuffisant pour ce lot ({{amount}} restant)"
        }
      },
      "sendToProduction": {
        "cta": "Envoyer en production",
        "onlyWaiting": "Seules les commandes En attente d'approbation et déjà payées peuvent être envoyées — désélectionnez les autres."
      },
      "cancelHint": {
        "onlyPreProduction": "Seules les commandes avant approbation (Brouillon / En attente d'approbation) peuvent être annulées. Les commandes déjà En production ne peuvent pas l'être — désélectionnez-les."
      }
    },
    "advancedFilter": {
      "_comment": "Phase 6 Wave 6 Task 21 — composeur de filtre avancé.",
      "title": "Filtre avancé",
      "addRule": "Ajouter règle",
      "apply": "Appliquer",
      "field": "Champ",
      "operator": "Opérateur",
      "value": "Valeur",
      "logic": "Logique",
      "operator.eq": "égal",
      "operator.ne": "différent",
      "operator.gt": "supérieur à",
      "operator.gte": "supérieur ou égal",
      "operator.lt": "inférieur à",
      "operator.lte": "inférieur ou égal",
      "operator.contains": "contient",
      "operator.in": "dans",
      "operator.notIn": "pas dans",
      "operator.between": "entre",
      "logicOp": {
        "AND": "ET",
        "OR": "OU",
        "WHERE": "OÙ"
      }
    },
    "customView": {
      "_comment": "Phase 6 Wave 6 Task 21 — page des vues personnalisées.",
      "nav": "Vues personnalisées",
      "create": "Créer une vue",
      "edit": "Modifier la vue",
      "savedViews": "Vues enregistrées",
      "empty": "Aucune vue enregistrée.",
      "selectOrCreate": "Sélectionnez une vue à modifier ou créez-en une nouvelle.",
      "save": "Enregistrer",
      "delete": "Supprimer",
      "apply": "Appliquer",
      "public": "Public",
      "private": "Privé",
      "noFilters": "Aucun filtre",
      "filterCount": "{{n}} règles",
      "archive": "Archives",
      "archiveDesc": "Commandes annulées automatiquement déplacées aux archives",
      "field": {
        "name": "Nom",
        "description": "Description",
        "columns": "Colonnes",
        "filters": "Filtres",
        "public": "Public (visible par tous les marchands)",
        "shareWith": "Partager avec des marchands (ids séparés par des virgules)"
      },
      "error": {
        "loadFailed": "Échec du chargement des vues",
        "saveFailed": "Échec de l'enregistrement",
        "deleteFailed": "Échec de la suppression"
      },
      "colsCount_one": "{{count}} col.",
      "colsCount_other": "{{count}} col.",
      "filtersCount_one": "{{count}} filtre(s)",
      "filtersCount_other": "{{count}} filtre(s)",
      "column": {
        "orderNumber": "N° commande",
        "product": "Produit",
        "quantity": "Quantité",
        "status": "Statut",
        "platform": "Plateforme",
        "customer": "Client",
        "items": "Articles",
        "total": "Total",
        "store": "Boutique",
        "created": "Créé le",
        "sla": "SLA",
        "actions": "Actions"
      }
    },
    "archive": {
      "_comment": "Phase 3.3 Amendment #3 — Archive custom view (bucket=archive).",
      "badge": "Archives",
      "emptyState": "Aucune commande archivée."
    },
    "settings": {
      "_comment": "Phase 6 Wave 6 Task 21 — paramètres commande marchand.",
      "title": "Paramètres commande",
      "save": "Enregistrer paramètres",
      "saved": "Enregistré",
      "defaultSync": "Synchroniser automatiquement les commandes",
      "defaultFulfillment": {
        "label": "Fulfilment par défaut",
        "option": {
          "manual": "Manuel",
          "auto": "Automatique",
          "review": "Vérification"
        }
      },
      "autoCancelTiming": "Annuler automatiquement (minutes)",
      "defaultShippingService": "Service d'expédition par défaut",
      "holdOnInventory": "Réserver le stock à la création",
      "notificationEmail": "E-mail de notification",
      "field": {
        "approvalMode": "Mode d'approbation",
        "threshold": "Seuil ($)",
        "enableNotifications": "Activer les notifications",
        "onShipped": "À l'expédition",
        "onDelivered": "À la livraison",
        "onExceptions": "En cas d'exception",
        "handlingMode": "Mode de traitement",
        "delayThreshold": "Seuil de retard (jours)",
        "autoEscalate": "Escalade automatique",
        "autoCancelAfter": "Annulation automatique après (minutes, 0 pour désactiver)",
        "defaultCarrier": "Transporteur par défaut",
        "cutoffTime": "Heure limite (HH:MM)",
        "timezone": "Fuseau horaire",
        "holdInventory": "Réserver le stock à la création de la commande (plutôt qu'au traitement)",
        "validationLevel": "Niveau de validation",
        "autoCorrect": "Corriger automatiquement les fautes de frappe si possible",
        "brandName": "Nom de la marque (De)",
        "replyToEmail": "E-mail de réponse",
        "internalNotificationEmail": "E-mail de notification interne"
      },
      "option": {
        "select": "— Sélectionner —",
        "approval": {
          "automatic": "Automatique",
          "manual": "Manuel",
          "threshold": "Basé sur un seuil"
        },
        "delay": {
          "manual": "Manuel",
          "auto-escalate": "Escalade automatique",
          "auto-reassign": "Réattribution automatique"
        },
        "fulfilment": {
          "manual": "Manuel",
          "auto": "Automatique",
          "review": "Révision d'abord"
        },
        "addressValidation": {
          "off": "Désactivé (accepter toute saisie)",
          "soft": "Souple (avertir en cas de doute)",
          "strict": "Strict (bloquer si invalide)"
        }
      },
      "status": {
        "enabled": "Activé",
        "disabled": "Désactivé",
        "autoSyncOn": "Synchro auto ACTIVÉE",
        "autoSyncOff": "Synchro auto DÉSACTIVÉE",
        "notSet": "Non défini",
        "default": "Par défaut",
        "off": "Désactivé",
        "soft": "Souple",
        "strict": "Strict",
        "holdOnCreate": "Réserver à la création",
        "holdAtFulfilment": "Réserver au traitement"
      },
      "error": {
        "loadFailed": "Échec du chargement des paramètres",
        "saveFailed": "Échec de l'enregistrement",
        "unavailable": "Paramètres indisponibles"
      },
      "placeholder": {
        "storeName": "Le nom de votre boutique",
        "replyToEmail": "support@yourbrand.com",
        "notificationEmail": "ops@yourbrand.com"
      },
      "addressValidation": {
        "desc": "Valider les adresses de livraison avant l'exécution",
        "title": "Validation des adresses"
      },
      "approval": {
        "desc": "Configurer le flux d'approbation",
        "label": "Approbation",
        "requireManager": "Exiger l'approbation d'un responsable",
        "title": "Approbation des commandes"
      },
      "automatic": "Automatique",
      "cancellation": {
        "desc": "Annuler automatiquement les commandes impayées après un délai",
        "title": "Annulation"
      },
      "customerComm": {
        "desc": "Identité e-mail affichée sur les messages destinés aux clients",
        "title": "Communication client"
      },
      "delay": {
        "desc": "Configurer la gestion des retards et l'escalade",
        "title": "Gestion des commandes retardées"
      },
      "delayedOrders": "Commandes retardées",
      "disabled": "Désactivé",
      "goTo": "Aller aux paramètres",
      "infobox": "Ces paramètres s'appliquent à chaque nouvelle commande reçue par ce compte marchand.",
      "inventory": {
        "desc": "Quand réserver le stock pour les nouvelles commandes",
        "title": "Inventaire"
      },
      "manual": "Manuel",
      "notifications": {
        "desc": "Paramètres de notification client",
        "title": "Notifications de suivi"
      },
      "routing": "Routage",
      "shipping": {
        "desc": "Transporteur par défaut + heure limite",
        "title": "Expédition"
      },
      "subtitle": "Configurez la façon dont vos commandes sont approuvées, suivies et exécutées.",
      "sync": {
        "desc": "Synchronisation auto depuis les boutiques connectées + exécution par défaut",
        "title": "Synchronisation et exécution"
      },
      "trackingNotif": "Notifications de suivi"
    },
    "resend": {
      "_comment": "Phase 6 Wave 6 Task 21 — popup de relance.",
      "title": "Renvoyer la commande",
      "reason": "Raison",
      "submit": "Renvoyer",
      "failed": "Échec du renvoi"
    },
    "newBanner": {
      "one": "1 nouvelle commande — cliquer pour charger",
      "other": "{{count}} nouvelles commandes — cliquer pour charger"
    },
    "sla": {
      "green": "Dans les délais",
      "yellow": "Échéance proche",
      "red": "En retard"
    },
    "columns": {
      "toggle": "Colonnes",
      "preset": {
        "compact": "Compact",
        "detailed": "Détaillé"
      },
      "product": "Produit",
      "qty": "Qté",
      "moreItems": "de plus",
      "order": "Commande",
      "status": "Statut",
      "platform": "Plateforme",
      "customer": "Client",
      "items": "Articles",
      "total": "Total",
      "store": "Boutique",
      "date": "Date",
      "sla": "SLA",
      "default": "Par défaut",
      "email": "E-mail",
      "surcharge": "Supplément",
      "orderType": "Type de commande",
      "receivedTime": "Heure de réception",
      "approvedTime": "Heure d'approbation",
      "late": "En retard",
      "actions": "Actions"
    },
    "platform": {
      "shopify": "Shopify",
      "etsy": "Etsy",
      "manual": "Manuel",
      "amazon": "Amazon",
      "tiktok": "TikTok"
    },
    "detail": {
      "_comment": "Phase 6 Wave 6 Task 18 — Order detail page copy. vg-binding: PLAN:task-18 / P6.D-44..51 / P6.D-243",
      "title": "Détail de la commande",
      "loadError": "Échec du chargement de la commande",
      "itemsTitle": "Articles",
      "address": {
        "shipping": "Adresse de livraison",
        "billing": "Adresse de facturation"
      },
      "tab": {
        "overview": "Aperçu",
        "activity": "Activité",
        "tracking": "Suivi"
      },
      "action": {
        "cancel": "Annuler",
        "reorder": "Recommander",
        "refund": "Rembourser",
        "printPacking": "Imprimer bon de livraison",
        "copied": "ID de commande copié dans le presse-papiers.",
        "createTicket": "Créer un ticket",
        "downloadInvoice": "Télécharger la facture",
        "edit": "Modifier",
        "editAddress": "Modifier l'adresse",
        "holdQueued": "Demande de mise en attente soumise au support. Notre équipe vous contactera sous peu.",
        "invoicePending": "Le téléchargement de la facture n'est pas encore disponible. Contactez le support si vous avez besoin d'une copie maintenant.",
        "more": "Plus d'actions",
        "payNow": "Payer maintenant",
        "reportIssue": "Signaler un problème",
        "requestCancel": "Demander l'annulation",
        "requestHold": "Demander une mise en attente",
        "sendToProduction": "Envoyer en production",
        "viewOnEtsy": "Voir sur Etsy",
        "viewOnShopify": "Voir sur Shopify",
        "viewOnSource": "Voir sur la boutique source",
        "duplicate": "Dupliquer la commande",
        "duplicating": "Duplication…"
      },
      "print": {
        "popupBlocked": "Popup bloqué — autorisez les popups pour voir le bon de livraison."
      },
      "cost": {
        "title": "Coûts",
        "products": "Produits",
        "shipping": "Livraison",
        "tax": "Taxes",
        "handling": "Frais de traitement",
        "surcharge": "Supplément",
        "seasonal": "Saison",
        "tariff": "Droits de douane",
        "embroidery": "Broderie",
        "digitizing": "Numérisation",
        "discount": "Remise",
        "total": "Total",
        "tip": {
          "products": "Somme des articles (quantité × prix unitaire).",
          "shipping": "Par groupe de livraison — plusieurs envois possibles.",
          "tax": "TVA / taxes selon destination.",
          "handling": "Frais de préparation et étiquetage.",
          "surcharge": "Supplément vendeur — taille, zone éloignée, etc.",
          "seasonal": "Frais saisonniers (Q4 / fêtes).",
          "tariff": "Droits / taxes à l'import.",
          "embroidery": "Coût de broderie selon le nombre de points.",
          "digitizing": "Frais unique de conversion en fichier de broderie.",
          "discount": "Remise promotionnelle — déjà signée."
        }
      },
      "cancel": {
        "title": "Annuler la commande",
        "submit": "Confirmer",
        "reason": {
          "label": "Raison",
          "customerRequest": "Demande client",
          "duplicate": "Doublon",
          "outOfStock": "Rupture de stock",
          "paymentIssue": "Problème de paiement",
          "other": "Autre"
        },
        "note": {
          "label": "Note (facultatif)"
        },
        "partial": {
          "label": "Annulation partielle"
        },
        "refund": {
          "label": "Remboursement au solde du portefeuille",
          "always": "Tous les remboursements vont au portefeuille — jamais au mode original"
        }
      },
      "activity": {
        "empty": "Aucune activité.",
        "actor": {
          "customer": "Client",
          "production": "Équipe production",
          "system": "Système",
          "merchant": "Marchand"
        },
        "showAll": "Voir les {{count}}",
        "showLess": "Réduire",
        "loading": "Chargement de l’activité…"
      },
      "tracking": {
        "empty": "Aucune information de suivi.",
        "estimatedDelivery": "Livraison prévue",
        "copyTrackingNumber": "Copier",
        "step": {
          "labelCreated": "Étiquette créée",
          "pickedUp": "Collecté",
          "inTransit": "En transit",
          "outForDelivery": "En cours de livraison",
          "delivered": "Livré"
        }
      },
      "shipping": {
        "method": {
          "merchant": "Expédié par le marchand",
          "tiktok": "Étiquette TikTok (fournie par l'acheteur)"
        },
        "label": {
          "view": "Voir l'étiquette",
          "none": "Aucune étiquette"
        }
      },
      "field": {
        "orderType": "Type de commande",
        "externalOrderId": "ID de commande externe",
        "manufacturingRegion": "Région de fabrication",
        "notAssigned": "Non attribué",
        "source": "Source"
      },
      "orderType": {
        "BASIC": "Basique",
        "SAMPLE": "Échantillon",
        "BULK_FBA_FBT": "En gros (FBA/FBT)",
        "BUNDLE": "Lot"
      },
      "shippingLabelAlt": "Étiquette d'expédition",
      "artwork": {
        "add": "Ajouter un visuel",
        "error": "Le visuel présente un problème — voir",
        "errorShort": "Erreur",
        "pass": "Visuel OK — voir"
      },
      "billing": {
        "paid": "Payé",
        "paidWithWallet": "Payé avec le portefeuille",
        "productionCost": "Coût de production",
        "shippingCost": "Frais d'expédition",
        "total": "Total",
        "transaction": "Transaction : {{ref}}",
        "unpaid": "Impayé",
        "viewInvoice": "Voir la facture"
      },
      "col": {
        "artwork": "Visuel",
        "product": "Produit",
        "qty": "Qté",
        "shippingFee": "Frais d'expédition",
        "sku": "SKU",
        "status": "Statut",
        "total": "Total",
        "unitPrice": "Prix unitaire"
      },
      "createdAt": "Créée le {{date}}",
      "editAddress": {
        "countryLocked": "Le pays ne peut pas être modifié.",
        "save": "Enregistrer et revérifier",
        "title": "Modifier l'adresse de livraison"
      },
      "fulfillment": {
        "cancelled": "Annulée",
        "delivered": "Livrée",
        "inProgress": "En cours",
        "pending": "En attente",
        "shipped": "Expédiée",
        "waiting": "En attente d'attribution à un site"
      },
      "item": {
        "addMoreMockup": "Ajouter un mockup",
        "artworkDefault": "Visuel",
        "artworks": "Visuels",
        "artworksHint": "Téléversez un fichier par zone d'impression",
        "chooseOrDrop": "Choisir ou glisser-déposer",
        "editInWizard": "Modifier la commande",
        "formats": "Formats",
        "imagesCount": "{{count}} images",
        "loadingAreas": "Chargement des zones d'impression…",
        "location": "Exécution",
        "lowRes": "Inférieur à 1000×1000px",
        "minDimensions": "Dimensions min.",
        "minResolution": "Résolution min.",
        "mockups": "Mockups",
        "mockupsHint": "Aperçus du produit",
        "noAreas": "Aucune zone d'impression définie pour ce produit",
        "noAreasHint": "Le mappage des visuels nécessite la configuration des zones d'impression du blueprint.",
        "pricing": "Tarification",
        "productInfo": "Informations sur le produit",
        "qtyTimesPrice": "Qté × Prix",
        "qualityStandards": "Normes de qualité Printway",
        "required": "Requis",
        "savingDots": "Enregistrement…",
        "tab": {
          "design": "Design et mockups",
          "details": "Détails"
        },
        "uploadFailed": "Échec du téléversement",
        "uploadForArea": "Téléverser le visuel {{area}}",
        "uploadMockup": "Téléverser des images de mockup",
        "uploadMockupHint": "Images d'aperçu du produit (PNG, JPG)",
        "uploading": "Téléversement…",
        "variant": "Variante",
        "openPreview": "Aperçu",
        "issue": {
          "heading": "Pourquoi cet article est signalé",
          "errorArtwork": "Le traitement du visuel de cet article a échoué. Consultez la zone d'impression ci-dessous pour savoir quoi corriger.",
          "onHold": "Cet article est en attente. Notre équipe est en train de l’examiner.",
          "pendingReassignment": "Cet article attend d'être réattribué à un partenaire de production. Aucune action n'est requise de votre part.",
          "attentionRequired": "Cet article nécessite une attention particulière — notre équipe a été prévenue.",
          "returnedPartial": "Cet article a été retourné.",
          "partiallyCancelled": "Cet article a été annulé.",
          "generic": "Cet article est signalé pour examen. Notre équipe s'en occupe — aucune action n'est requise de votre part.",
          "noAreaDetail": "Aucun détail par zone n'est disponible pour cet échec — il provient de notre chaîne de traitement, pas de votre fichier. Contactez le support s'il persiste."
        }
      },
      "lineItem": {
        "artworkCount": "{{count}} visuel",
        "viewArtwork": "Voir les visuels et mockups"
      },
      "pay": {
        "modalTitle": "Payer la commande {{order}}",
        "success": "Commande payée depuis votre portefeuille."
      },
      "refunded": {
        "label": "Remboursé : {{amount}}"
      },
      "section": {
        "activity": "Chronologie d'activité",
        "billing": "Facturation",
        "customer": "Client",
        "fulfillment": "Exécution",
        "havingIssue": "Vous rencontrez un problème ?",
        "havingIssueHint": "Signalez des problèmes de production, d'expédition ou de qualité",
        "lineItems": "Lignes d'articles",
        "lineItemsHint": "Cliquez sur un article pour voir les visuels et mockups",
        "orderInfo": "Infos commande",
        "shipmentTracking": "Suivi de l'expédition",
        "shippingAddress": "Adresse de livraison",
        "status": "Statut de la commande"
      },
      "sendToProduction": {
        "confirmBody": "La commande {{order}} sera transmise au fournisseur pour démarrer la production. Après cette étape, la commande passe au statut In Production.",
        "confirmCta": "Confirmer l'envoi",
        "confirmTitle": "Envoyer cette commande en production ?",
        "processing": "Envoi…",
        "success": "Commande envoyée en production.",
        "tooltip": "Envoyez cette commande au fournisseur pour lancer la production.",
        "error": "Impossible d'envoyer en production."
      },
      "artworkBlocked": {
        "title": "Illustration non validée",
        "body": "Ces zones d'impression nécessitent une illustration validée avant que cette commande puisse être envoyée en production.",
        "areaRow": "{{item}} — {{area}}",
        "fixCta": "Corriger l'illustration",
        "dismiss": "Ignorer",
        "itemFallback": "Article"
      },
      "shipmentTracking": {
        "empty": "Aucune information d'expédition disponible pour le moment",
        "eta": "Livraison estimée"
      },
      "status": {
        "cancelled": "Cette commande a été annulée.",
        "errorArtwork": "Cette commande a une erreur d'artwork — corrigez la ligne signalée pour continuer.",
        "pendingReassignment": "Cette commande attend d'être réattribuée à un partenaire de production. Aucune action requise de votre part.",
        "onHold": "Cette commande est en attente. Notre équipe la vérifie.",
        "attentionRequired": "Cette commande nécessite votre attention — veuillez vérifier les lignes.",
        "returnedPartial": "Une partie de cette commande a été retournée.",
        "partiallyCancelled": "Une partie de cette commande a été annulée.",
        "issueGeneric": "Cette commande nécessite une attention. Notre équipe l'examine."
      },
      "totals": {
        "shipping": "Expédition",
        "subtotal": "Sous-total",
        "tax": "Taxe",
        "total": "Total"
      },
      "duplicate": {
        "success": "Commande dupliquée — ouverture de la nouvelle commande…",
        "error": "Échec de la duplication de la commande."
      }
    },
    "payment": {
      "_comment": "Phase 6 Wave 7 Task 22 — Order payment step copy. vg-binding: PLAN:task-22 / P6.D-59 / P6.D-59c / P6.D-231 / P6.D-239 / P6.D-240 / P6.D-241 / P6.D-242 / G-37 / G-38",
      "title": "Paiement",
      "method": {
        "wallet": "Wallet",
        "stripe": "Carte bancaire (Stripe)",
        "paypal": "PayPal",
        "credit": "Crédit",
        "credit.insufficient": "Crédit restant insuffisant",
        "credit.subRemaining": "Disponible : {{remaining}}",
        "credit.expires": "expire le {{date}}",
        "wallet.subBalance": "Solde : {{balance}}",
        "insufficientBalance": "Solde insuffisant — recharger",
        "topupCta": "Recharger",
        "teamMemberOnly": "Membres d'équipe : Wallet uniquement",
        "gatewayComingSoon": "Le paiement par carte n'est pas encore disponible — utilisez votre portefeuille ou votre crédit.",
        "stripe.needsCard": "Aucune carte enregistrée — en ajouter une",
        "stripe.checking": "Vérification en cours…",
        "stripe.willCharge": "Débite {{card}}",
        "stripe.declined": "Carte refusée — utilisez un autre moyen de paiement",
        "stripe.notAllowed": "Le paiement par carte n'est pas activé pour votre compte",
        "stripe.unavailable": "Impossible de joindre le prestataire de paiement — veuillez réessayer"
      },
      "payLater": {
        "label": "Payer plus tard",
        "help": "Crée une dette Wallet — Wallet uniquement"
      },
      "creditDebt": {
        "warning": "Vous devez {{credit}}. Paiement par {{method}} ne réduit pas la dette — choisissez Wallet.",
        "ack": "Compris"
      },
      "confirm": {
        "button": "Confirmer le paiement",
        "processing": "Traitement..."
      },
      "error": {
        "400": "Requête invalide",
        "402": "Solde insuffisant — rechargez d'abord",
        "503": "Passerelle indisponible — réessayer"
      },
      "landing": {
        "verifying": "Vérification du paiement...",
        "timeout": "Paiement en cours de réconciliation. Vous recevrez une notification.",
        "failed": {
          "title": "Échec du paiement",
          "retry": "Réessayer",
          "backToOrders": "Retour aux commandes"
        },
        "success": {
          "title": "Paiement réussi"
        }
      },
      "paid": "Payé",
      "partial_paid": "Partiellement payé",
      "skip": {
        "button": "Ignorer le paiement (payer plus tard)",
        "help": "Créer la commande en Draft + Unpaid et payer plus tard."
      },
      "unpaid": "Impayé"
    },
    "refund": {
      "_comment": "Phase 6 Wave 7 Task 23 — Refund flow copy. vg-binding: PLAN:task-23 / P6.D-46 / P6.D-243 / G-39",
      "title": "Rembourser la commande",
      "toWallet": "→ Solde du portefeuille",
      "disclaimer": "Tous les remboursements vont au solde du portefeuille. Pour un remboursement CC/PayPal original, contactez Admin Support.",
      "reason": {
        "label": "Raison du remboursement",
        "defectiveProduct": "Produit défectueux",
        "wrongItemShipped": "Mauvais article",
        "customerChangedMind": "Client a changé d'avis",
        "qualityIssue": "Problème de qualité",
        "shippingDamage": "Dommage d'expédition"
      },
      "note": {
        "label": "Note (facultatif)"
      },
      "items": {
        "title": "Articles à rembourser",
        "amountLabel": "Montant remboursé",
        "maxOriginal": "Max : {{amount}}",
        "empty": "Aucun article remboursable."
      },
      "total": {
        "label": "Total remboursé"
      },
      "submit": "Confirmer le remboursement",
      "submitting": "Traitement...",
      "success": "Remboursement réussi",
      "error": "Échec du remboursement",
      "validation": {
        "minSelect": "Sélectionnez au moins 1 article",
        "exceedTotal": "Remboursement dépasse le total",
        "generic": "Impossible d'envoyer la demande — vérifiez le formulaire."
      },
      "refundAria": "Rembourser {{name}}"
    },
    "chargeback": {
      "_comment": "Phase 6 Wave 7 Task 23 — Chargeback display copy. vg-binding: PLAN:task-23 / P6.D-243 / G-39",
      "title": "Litige",
      "status": {
        "opened": "Ouvert",
        "evidenceRequired": "Preuve requise",
        "lost": "Perdu",
        "won": "Gagné",
        "closed": "Fermé"
      },
      "openedAt": "Ouvert le",
      "evidenceDueBy": "Preuve due le",
      "adminHandled": "Géré par Admin Support — voir notes"
    },
    "badge": {
      "draft": "Brouillon",
      "unverified": "Non vérifié",
      "pending": "En attente",
      "waiting": "En attente d'approbation",
      "processing": "En production",
      "shipped": "Expédié",
      "delivered": "Terminé",
      "cancelled": "Annulé",
      "issues": "Problèmes",
      "paid": "Payé",
      "partialPaid": "Partiellement payé",
      "embFeeDue": "Frais de broderie dus",
      "unpaid": "Non payé",
      "refunded": "Remboursé",
      "unknown": "Inconnu",
      "waitingPayment": "En attente de paiement",
      "late": "En retard"
    },
    "table": {
      "header": {
        "order": "Commande",
        "status": "Statut",
        "platform": "Plateforme",
        "customer": "Client",
        "items": "Articles",
        "total": "Total",
        "store": "Boutique",
        "created": "Date de création",
        "sla": "SLA",
        "orderType": "Type de commande",
        "receivedTime": "Heure de réception",
        "approvedTime": "Heure d'approbation",
        "payment": "Paiement",
        "shippingName": "Nom du destinataire",
        "seller": "Nom du vendeur",
        "tracking": "Suivi",
        "label": "Étiquette",
        "location": "Emplacement",
        "embroidery": "Prix de la broderie",
        "surcharge": "Surcharge",
        "email": "E-mail",
        "late": "En retard",
        "artwork": "Visuel"
      },
      "item": "article",
      "items": "articles",
      "viewArtwork": "Voir l'illustration",
      "collapseItems": "Réduire les articles",
      "expandItems": "Afficher les articles",
      "view": "Voir",
      "copyTracking": "Copier le numéro de suivi",
      "trackingMore": "+{{count}} autres",
      "locationMore": "+{{count}} autres",
      "artworkPerItem": "{{count}} articles"
    },
    "itemStatus": {
      "draft": "Brouillon",
      "unverified": "Non vérifié",
      "pending": "En attente",
      "waiting": "En attente d'approbation",
      "processing": "En production",
      "shipped": "Expédié",
      "delivered": "Livré",
      "cancelled": "Annulé",
      "issues": "Problèmes"
    },
    "artworkDrawer": {
      "title": "Artwork",
      "loading": "Chargement…",
      "itemNotFound": "Article introuvable.",
      "empty": "Cet article n'a pas de modèle d'artwork et aucun artwork n'est encore associé.",
      "ingestStatus": "Statut d'import de l'artwork",
      "requirementsHeading": "Exigences d'artwork par zone d'impression",
      "attached": "Associé",
      "noArtwork": "Aucun artwork",
      "requirementLabel": "Requis : ",
      "noRequirement": "Aucune exigence de modèle pour cette zone.",
      "actualLabel": "Réel : "
    },
    "shippingField": {
      "orderName": "Nom de la commande",
      "shippingLabel": "Étiquette d'expédition",
      "recipient": "Destinataire",
      "address": "Adresse",
      "city": "Ville",
      "country": "Pays",
      "postalCode": "Code postal"
    },
    "artworkSpec": {
      "formatInvalid": "Le format {{fmt}} n'est pas autorisé — requiert {{required}}",
      "widthMismatch": "Largeur {{actual}}px ≠ requis {{required}}px",
      "heightMismatch": "Hauteur {{actual}}px ≠ requis {{required}}px",
      "extensionInvalid": "Le format {{actual}} n’est pas autorisé — {{required}} requis",
      "dimensionMismatch": "La taille {{actual}}px ne correspond pas aux {{required}}px requis",
      "dpiTooLow": "La résolution {{actual}} DPI est inférieure aux {{required}} DPI requis",
      "decodeFailed": "Image illisible — le fichier est peut-être corrompu."
    },
    "wizard": {
      "step": {
        "invalidLabelLink": "Lien invalide (doit commencer par http:// ou https://)",
        "uploadLabelFailed": "Échec du téléversement de l'étiquette",
        "uploading": "Téléversement…",
        "labelLinkPlaceholder": "https://… lien vers le fichier d'étiquette",
        "labelUploaded": "Étiquette téléversée",
        "labelLinked": "Lien d'étiquette ajouté",
        "emailPlaceholder": "name@example.com",
        "orderNameRequired": "Le nom de la commande est obligatoire — veuillez le saisir dans le champ en haut de la page (à côté du titre).",
        "labelRequired": "Veuillez téléverser une étiquette à l'étape Expédition (méthode étiquette Marketplace).",
        "artworkCheckingRetry": "Vérification des exigences de visuel — veuillez patienter un instant puis réessayer.",
        "artworkMissing": "Des zones d'impression obligatoires n'ont toujours pas de visuel : {{areas}}. Veuillez revenir à l'étape Visuel pour téléverser.",
        "updateOrderFailed": "Échec de la mise à jour de la commande",
        "createDraftFailed": "Échec de la création du brouillon",
        "wrongSize": "mauvaise taille",
        "uploadArtworkFailed": "Échec du téléchargement du visuel — réessayez.",
        "addressIncomplete": "Champs d'expédition manquants : {{fields}}",
        "variantUnresolved": "Certains articles ont une variante qui ne correspond pas au blueprint. Le produit a peut-être été créé avec une variante provisoire — recréez-le pour que sa taille/couleur proviennent du blueprint."
      }
    },
    "cancel": {
      "qtyAria": "Quantité de {{productName}} à annuler"
    },
    "tracking": {
      "openAria": "Ouvrir le suivi {{carrier}} dans un nouvel onglet"
    },
    "bulkDiscount": {
      "cta": "En savoir plus"
    },
    "edit": {
      "review": {
        "saveAndPay": "Enregistrer les modifications et continuer vers le paiement",
        "saveOnly": "Enregistrer les modifications (payer plus tard)"
      },
      "title": "Modifier la commande"
    },
    "export": {
      "action": "Exporter"
    },
    "flash": {
      "paidStub": "Paiement confirmé en sandbox. La persistance des commandes sera mise en place lors d'une prochaine vague — votre brouillon n'est pas encore visible dans la liste ci-dessous.",
      "savedDraft": "La commande a été enregistrée. Vous pourrez la payer plus tard depuis la page de détail de la commande."
    },
    "status": {
      "draft": "Brouillon",
      "unverified": "Non vérifié",
      "pending": "En attente",
      "waitingApproval": "En attente d'approbation",
      "inProduction": "En production",
      "shipped": "Expédié",
      "delivered": "Livré",
      "cancelled": "Annulé",
      "issues": "Problèmes"
    },
    "timeline": {
      "new": "Nouveau",
      "approval": "Approbation",
      "production": "En production",
      "shipped": "Expédié",
      "delivered": "Livré"
    },
    "activity": {
      "by": "par"
    },
    "sub": {
      "artworkNone": "Aucun visuel",
      "artworkOk": "Visuel",
      "shipping": "Livraison",
      "unit": "Unité"
    },
    "checkout": {
      "cost": {
        "title": "Coût de la commande",
        "subtitle": "Mis à jour en direct depuis le devis",
        "subtotal": "Sous-total produits",
        "discount": "Remise",
        "shipping": "Livraison",
        "seasonal": "Frais haute saison",
        "tax": "Taxe",
        "tariff": "Tarif réciproque",
        "duty": "Droits d'importation (DDP)",
        "digitizing": "Frais de numérisation",
        "rush": "Express",
        "handling": "Frais de traitement",
        "embroidery": "Broderie",
        "embroideryPending": "En attente de numérisation",
        "embroideryPendingTooltip": "La broderie est facturée au nombre de points — finalisée après la numérisation.",
        "embroideryExcluded": "Hors broderie (en attente de numérisation)",
        "empty": "Ajoutez des produits pour voir le détail des coûts.",
        "total": "Total",
        "confirm": "Confirmer et payer",
        "confirming": "Confirmation…",
        "disclaimer": "Le devis est indicatif — le prix final est verrouillé à la confirmation de la commande.",
        "degradeTooltip": "Saisissez une adresse de livraison pour calculer les frais par zone.",
        "error": {
          "title": "Impossible d'obtenir un devis",
          "retry": "Réessayer"
        },
        "confirmBlocked": {
          "quoteFailed": "Confirmation impossible — le recalcul a échoué. Réessayez le devis.",
          "priceMissing": "Retirez les articles sans prix pour continuer.",
          "needsAddress": "Saisissez une adresse de livraison pour obtenir un prix final.",
          "noPrice": "En attente d'un prix réel du système."
        }
      },
      "groups": {
        "title": "Groupes d'expédition",
        "subtitle": "Les articles sont regroupés en colis par lieu de production et classe d'emballage.",
        "empty": "Aucun groupe d'expédition — ajoutez des produits au panier.",
        "groupName": "Groupe {{n}}",
        "itemCount": "{{count}} articles",
        "reasonTooltip": "Ces articles sont expédiés ensemble — même lieu de production et classe d'emballage.",
        "qtyLine": "Qté : {{count}}",
        "anchorBadge": "Ancre",
        "anchorTooltip": "Article d'ancrage — facturé les frais du premier colis du groupe.",
        "accessoryBadge": "Accessoire",
        "accessoryTooltip": "Accessoire groupé — pas de frais d'expédition supplémentaires.",
        "serviceLabel": "Service d'expédition",
        "serviceOption": "{{label}} — {{price}}",
        "serviceOptionEta": "{{label}} — {{eta}} jours — {{price}}",
        "degradeTooltip": "Saisissez une adresse de livraison pour calculer les frais par zone.",
        "rush": {
          "title": "Express",
          "desc": "L’activation relance le devis.",
          "descWithFee": "Produit sous 48 h — frais supplémentaires. L’activation relance le devis.",
          "toggleAria": "Activer la production express"
        }
      },
      "priceDrift": {
        "title": "Le prix a changé",
        "desc": "Certains frais ont changé depuis le devis que vous consultiez. Vérifiez avant de continuer.",
        "col": {
          "item": "Poste",
          "old": "Ancien prix",
          "new": "Nouveau prix",
          "total": "Total"
        },
        "backToCart": "Retour au panier",
        "accept": "Accepter le nouveau prix",
        "confirming": "Confirmation…"
      }
    },
    "orderType": {
      "bundle": "Lot"
    }
  },
  "stores": {
    "_comment": "Phase 6 Wave 8 Task 25 / Task 26 / Task 27 — Connect-store surface + Store detail page + cross-store sync surface (P6.D-107..114 / P6.D-202 / P6.D-112 / P6.D-223 / P6.D-237 / G-41..G-45).",
    "list": {
      "title": "Boutiques",
      "subtitle": "Gérez vos boutiques e-commerce connectées"
    },
    "filter": {
      "platform": {
        "label": "Plateforme",
        "all": "Toutes les plateformes"
      },
      "status": {
        "label": "Statut",
        "all": "Tous les statuts"
      }
    },
    "view": {
      "grid": "Grille",
      "list": "Liste"
    },
    "connectNew": "Connecter une boutique",
    "platform": {
      "shopify": "Shopify",
      "etsy": "Etsy",
      "amazon": "Amazon",
      "tiktok": "TikTok Shop",
      "woocommerce": "WooCommerce",
      "manual": "Manuelle"
    },
    "empty": {
      "title": "Aucune boutique connectée",
      "subtitle": "Connectez votre première boutique pour synchroniser produits et commandes.",
      "cta": "Connecter la première boutique"
    },
    "kpi": {
      "activeStores": "Boutiques actives",
      "productsSynced": "Total produits",
      "totalOrders": "Commandes en attente"
    },
    "card": {
      "productCount": "{{count}} produits",
      "lastSync": "Dernière sync {{time}}",
      "menu": {
        "syncNow": "Synchroniser",
        "view": "Voir",
        "disconnect": "Déconnecter"
      },
      "orders": "Commandes",
      "products": "Produits",
      "settings": "Paramètres",
      "sync": "Synchroniser",
      "syncFailed": "Impossible de démarrer la synchronisation",
      "syncQueued": "Synchronisation démarrée",
      "code": "Code de boutique (utilisé pour l'import en masse)",
      "statusLabel": {
        "active": "Connecté",
        "paused": "En pause",
        "disconnected": "Erreur",
        "pending": "En attente"
      }
    },
    "syncLogs": {
      "aggregation": {
        "title": "Journaux de sync",
        "filter": {
          "platform": "Plateforme",
          "store": "Boutique"
        },
        "column": {
          "store": "Boutique"
        },
        "allPlatforms": "Toutes plateformes",
        "allStatuses": "Tous statuts",
        "allStores": "Toutes boutiques",
        "allTypes": "Tous types"
      },
      "allStores": "Toutes les boutiques",
      "allPlatforms": "Toutes les plateformes",
      "allTypes": "Tous types",
      "allStatuses": "Tous statuts"
    },
    "externalProducts": {
      "title": "Produits externes",
      "editMapping": "Modifier le mapping",
      "empty": "Aucun produit externe pour l'instant.",
      "filter": {
        "all": "Tous",
        "mapped": "Mappés",
        "unmapped": "Non mappés",
        "review": "À vérifier"
      },
      "column": {
        "title": "Titre",
        "sku": "SKU externe",
        "mapped": "Produit Printway",
        "lastSync": "Dernière sync"
      }
    },
    "disconnect": {
      "title": "Déconnecter la boutique",
      "banner": "Vous allez déconnecter la boutique {{name}}",
      "consequences": {
        "h": "Après déconnexion :"
      },
      "consequence": {
        "ordersKeep": "Commandes conservées",
        "noNewSync": "Plus de sync",
        "productsKept": "Produits gardés",
        "canReconnect": "Reconnexion possible"
      },
      "reasonLabel": "Raison (facultatif)",
      "reasonOptional": "— Choisir une raison (facultatif) —",
      "reason": {
        "switchingPlatform": "Changement de plateforme",
        "closingStore": "Fermeture de boutique",
        "troubleshooting": "Dépannage",
        "other": "Autre"
      },
      "confirmType": "Tapez \"disconnect\" pour confirmer",
      "confirmBtn": "Déconnecter",
      "reconnectBtn": "Reconnecter",
      "successToast": "Boutique déconnectée.",
      "success": "Boutique déconnectée."
    },
    "syncSettings": {
      "advanced": {
        "title": "Paramètres sync avancés"
      },
      "resources": {
        "h": "Ressources synchronisées"
      },
      "resource": {
        "products": "Produits",
        "orders": "Commandes",
        "inventory": "Inventaire",
        "customers": "Clients"
      },
      "retryPolicy": "Politique de réessai",
      "retry": {
        "immediate": "Immédiat",
        "exponential": "Exponentiel",
        "fixed_interval": "Intervalle fixe"
      },
      "maxRetries": "Tentatives maximales",
      "alertEmail": "Email d'alerte",
      "syncWindow": "Fenêtre de sync",
      "windowStart": "Début",
      "windowEnd": "Fin",
      "windowTz": "Fuseau horaire",
      "pause": "Suspendre la sync",
      "resume": "Reprendre la sync"
    },
    "syncOrders": {
      "title": "Synchroniser commandes",
      "narrow": "Sync ciblée",
      "sinceDate": "Depuis",
      "specificOrder": "Commande spécifique",
      "runNarrow": "Exécuter la sync ciblée",
      "jobStatus": "Job en cours : {{jobId}}"
    },
    "syncProducts": {
      "title": "Synchroniser produits",
      "narrow": "Sync ciblée",
      "skuPrefix": "Préfixe SKU",
      "oosOnly": "Rupture seulement",
      "runNarrow": "Exécuter la sync ciblée",
      "jobStatus": "Job en cours : {{jobId}}"
    },
    "status": {
      "active": "Active",
      "paused": "En pause",
      "disconnected": "Déconnectée",
      "pending": "En attente"
    },
    "detail": {
      "_comment": "Phase 6 Wave 8 Task 26 — Page de détail boutique.",
      "back": "Retour aux boutiques",
      "loadError": "Impossible de charger les détails de la boutique",
      "notFound": "Boutique introuvable",
      "actions": "Actions",
      "tabsAriaLabel": "Onglets de gestion de la boutique",
      "disconnectTitle": "Déconnecter la boutique ?",
      "disconnectBody": "Vous allez déconnecter {{name}}. Toutes les synchronisations automatiques seront arrêtées. Vous pouvez reconnecter plus tard.",
      "disconnectInProgress": "Déconnexion…",
      "tab": {
        "overview": "Vue d'ensemble",
        "mapping": "Centre de mapping",
        "syncLogs": "Journaux de synchronisation",
        "settings": "Paramètres"
      },
      "action": {
        "syncProducts": "Synchroniser les produits",
        "syncOrders": "Synchroniser les commandes",
        "disconnect": "Déconnecter"
      },
      "toast": {
        "syncProductsQueued": "Synchronisation des produits en file d'attente.",
        "syncOrdersQueued": "Synchronisation des commandes en file d'attente.",
        "syncFailed": "Impossible de démarrer la synchronisation. Veuillez réessayer.",
        "disconnectFailed": "Impossible de déconnecter la boutique. Veuillez réessayer."
      },
      "kpi": {
        "connectedSince": "Connectée depuis",
        "totalProducts": "Total produits",
        "totalOrders": "Total commandes",
        "revenue30d": "Revenus (30 j)",
        "lastSync": "Dernière synchronisation",
        "syncStatus": "Statut de sync"
      },
      "health": {
        "label": "État :",
        "healthy": "En bonne santé",
        "warning": "À vérifier",
        "disconnected": "Déconnectée"
      },
      "recentActivity": "Activité de synchronisation récente",
      "viewAllLogs": "Voir tous les journaux",
      "noActivity": "Aucune activité de synchronisation pour l'instant.",
      "recordsCount": "{{count}} enregistrements",
      "mapping": {
        "title": "Centre de mapping",
        "filterAriaLabel": "Filtres de mapping",
        "filter": {
          "all": "Tous",
          "unmapped": "Non mappé",
          "high-confidence": "Confiance élevée (>85%)",
          "review": "Vérification manuelle"
        },
        "batchConfirm": "Confirmer en lot (confiance élevée)",
        "batchConfirmDone": "{{count}} lignes confirmées.",
        "saveDone": "Mapping enregistré.",
        "unmappedFilter": "Non mappé",
        "highConfidence": "Confiance élevée",
        "confidence": "Confiance",
        "noScore": "—",
        "statusReview": "À vérifier",
        "statusUnmapped": "Non mappé",
        "edit": "Modifier",
        "editTitle": "Modifier le mapping produit",
        "productIdLabel": "ID produit Printway",
        "productIdPlaceholder": "Saisissez un ID produit/variant…",
        "suggestionLabel": "Suggestion",
        "totalRows": "{{count}} lignes",
        "empty": "Aucun produit dans ce filtre.",
        "column": {
          "externalSku": "SKU externe",
          "externalTitle": "Titre externe",
          "mappedProduct": "Produit Printway",
          "confidence": "Confiance",
          "action": "Action"
        }
      },
      "syncLogs": {
        "empty": "Aucun journal de synchronisation.",
        "retry": "Réessayer",
        "retryQueued": "Nouvelle tentative en file d'attente.",
        "pageOf": "Page {{page}} sur {{total}}",
        "filter": {
          "type": "Type",
          "status": "Statut",
          "from": "Du",
          "to": "Au",
          "allTypes": "Tous types",
          "allStatuses": "Tous statuts"
        },
        "type": {
          "products": "Produits",
          "orders": "Commandes",
          "inventory": "Inventaire"
        },
        "status": {
          "success": "Succès",
          "partial": "Partiel",
          "failed": "Échec"
        },
        "column": {
          "timestamp": "Horodatage",
          "type": "Type",
          "status": "Statut",
          "records": "Enregistrements",
          "duration": "Durée",
          "action": "Action"
        }
      },
      "settings": {
        "autoSyncProducts": "Synchroniser les produits automatiquement",
        "autoSyncProductsHelp": "Récupère automatiquement les produits dans Printway.",
        "autoSyncOrders": "Synchroniser les commandes automatiquement",
        "autoSyncOrdersHelp": "Récupère automatiquement les nouvelles commandes dans Printway.",
        "syncInterval": "Intervalle de synchronisation",
        "intervalOption": "{{minutes}} minutes",
        "webhookUrl": "URL Webhook",
        "webhookUrlPlaceholder": "Pas de webhook",
        "fulfillmentPolicy": "Politique de traitement par défaut",
        "fulfillment": {
          "manual": "Manuel",
          "auto": "Automatique",
          "review": "Validation requise"
        },
        "inventorySync": "Synchronisation de l'inventaire",
        "inventorySyncHelp": "Renvoie les niveaux d'inventaire vers la plateforme.",
        "currency": "Devise",
        "save": "Enregistrer les paramètres",
        "saving": "Enregistrement…",
        "saveDone": "Paramètres enregistrés.",
        "copyFailed": "Copie impossible. Veuillez copier manuellement.",
        "dangerZone": "Zone de danger",
        "dangerZoneBody": "Déconnecter cette boutique arrête toute synchronisation automatique.",
        "disconnect": "Déconnecter la boutique",
        "disconnectConfirm": "Confirmer la déconnexion de cette boutique ?",
        "approvalTime": "Délai d'approbation des commandes",
        "approvalTimeHelp": "Combien de temps attendre après la synchronisation d'une commande avant de l'envoyer automatiquement en production. Activez la synchronisation auto des commandes pour l'utiliser.",
        "approvalTimeOption": {
          "1h": "Après 1 heure",
          "30m": "Après 30 minutes",
          "4h": "Après 4 heures",
          "immediate": "Immédiat"
        }
      },
      "codeLabel": "Code",
      "rename": {
        "required": "Le nom de la boutique est requis.",
        "success": "Boutique renommée.",
        "failed": "Impossible de renommer la boutique.",
        "edit": "Modifier le nom de la boutique"
      },
      "code": "Code de boutique (utilisé pour l'import en masse)"
    },
    "connect": {
      "title": "Connecter une boutique",
      "subtitle": "Choisissez une plateforme pour connecter votre boutique.",
      "platform": {
        "shopify": "Shopify",
        "shopifyDesc": "Connectez via OAuth en utilisant votre domaine.",
        "woocommerce": "WooCommerce",
        "woocommerceDesc": "Connectez avec les clés API REST de WordPress.",
        "tiktok": "TikTok Shop",
        "tiktokDesc": "Connectez TikTok Shop via OAuth.",
        "etsy": "Etsy",
        "etsyDesc": "OAuth natif prochainement — utilisez l'extension Chrome ci-dessous.",
        "amazon": "Amazon",
        "amazonDesc": "Intégration Amazon Seller native prochainement.",
        "manual": "Boutique manuelle",
        "manualDesc": "Suivez une boutique hors-ligne / autonome manuellement.",
        "available": "Disponible",
        "comingSoon": "Prochainement"
      },
      "etsyExtension": "Utiliser l'extension Etsy",
      "shopify": {
        "title": "Connecter Shopify",
        "subtitle": "Saisissez votre domaine Shopify pour démarrer OAuth.",
        "domainLabel": "Domaine Shopify",
        "connect": "Connecter Shopify",
        "help": "Trouvez-le dans Shopify admin → Paramètres → Domaines. Nous vous redirigerons vers Shopify pour autoriser l'accès.",
        "helpLink": "En savoir plus",
        "invalidDomain": "Saisissez un domaine Shopify valide (ex. your-shop.myshopify.com).",
        "unknownError": "Impossible de démarrer la connexion Shopify. Veuillez réessayer.",
        "feat": {
          "inventory": {
            "subtitle": "Synchronisation de l'inventaire en temps réel sur toutes les plateformes",
            "title": "Gestion de l'inventaire"
          },
          "orders": {
            "subtitle": "Les commandes arrivent directement sur votre dashboard",
            "title": "Synchronisation automatique des commandes"
          },
          "publish": {
            "subtitle": "Publiez vos produits directement sur Shopify",
            "title": "Publication de produits"
          }
        },
        "redirectNote": "Vous serez redirigé vers Shopify pour autoriser l'accès à votre boutique.",
        "urlHeading": "Saisissez l'URL de votre boutique Shopify",
        "urlHint": "Saisissez votre domaine myshopify.com"
      },
      "woo": {
        "title": "Connecter WooCommerce",
        "subtitle": "Collez vos identifiants REST API WooCommerce.",
        "urlLabel": "URL du site",
        "keyLabel": "Consumer Key",
        "secretLabel": "Consumer Secret",
        "connect": "Connecter WooCommerce",
        "helpTitle": "Où les trouver",
        "help1": "WP Admin → WooCommerce → Réglages → Avancé → REST API.",
        "help2": "Cliquez sur « Ajouter une clé », réglez les permissions sur Lecture/Écriture puis Générer.",
        "help3": "Copiez la Consumer Key + Consumer Secret ici.",
        "invalidUrl": "Saisissez une URL HTTPS valide (ex. https://shop.example.com).",
        "missingCreds": "Consumer Key et Consumer Secret sont tous deux requis.",
        "successToast": "Boutique WooCommerce connectée.",
        "unknownError": "Impossible de connecter la boutique WooCommerce. Vérifiez les identifiants et réessayez.",
        "credsHeading": "Saisissez vos identifiants API",
        "credsHelp": "Générez une clé REST API en lecture/écriture dans votre admin WooCommerce et collez-la ici.",
        "feat": {
          "inventory": {
            "subtitle": "Synchronisation de l'inventaire en temps réel sur toutes les plateformes",
            "title": "Gestion de l'inventaire"
          },
          "orders": {
            "subtitle": "Les commandes arrivent directement sur votre dashboard",
            "title": "Synchronisation automatique des commandes"
          },
          "publish": {
            "subtitle": "Publiez vos produits directement sur WooCommerce",
            "title": "Publication de produits"
          }
        },
        "step": {
          "creds": "Identifiants API",
          "url": "URL de la boutique",
          "verify": "Vérifier la connexion"
        },
        "urlHeading": "Saisissez l'URL de votre boutique",
        "urlHelp": "Saisissez l'URL principale de votre boutique WooCommerce. Assurez-vous que WooCommerce est installé et actif sur votre boutique.",
        "urlHint": "Saisissez l'URL complète, y compris https://",
        "verifying": "Vérification de la connexion…",
        "verifyingHelp": "Vérification de l'URL de votre boutique et des identifiants REST API."
      },
      "tiktok": {
        "title": "Connecter TikTok Shop",
        "subtitle": "Autorisez Printway à gérer produits et commandes sur votre TikTok Shop.",
        "connect": "Connecter TikTok",
        "helpTitle": "Comment ça marche",
        "help1": "Cliquez sur Connecter pour ouvrir TikTok Shop dans une nouvelle fenêtre.",
        "help2": "Connectez-vous avec le compte vendeur à associer.",
        "help3": "Approuvez les permissions demandées, vous reviendrez ici.",
        "unknownError": "Impossible de démarrer la connexion TikTok Shop. Veuillez réessayer.",
        "access": {
          "inventory": "Inventaire - Maintenir synchronisé",
          "orders": "Commandes - Synchroniser automatiquement",
          "products": "Produits - Publier et gérer"
        },
        "accessIntro": "Vous serez redirigé vers TikTok pour autoriser la connexion. Nous accéderons à :",
        "feat": {
          "analytics": {
            "subtitle": "Suivez les performances de vente et les tendances depuis votre dashboard",
            "title": "Analyses et insights"
          },
          "connect": {
            "subtitle": "Connectez votre TikTok Shop en un clic avec OAuth",
            "title": "Connexion fluide de la boutique"
          },
          "orders": {
            "subtitle": "Les commandes arrivent directement sur votre dashboard Printway",
            "title": "Synchronisation automatique des commandes"
          },
          "publish": {
            "subtitle": "Publiez vos produits POD directement sur TikTok Shop",
            "title": "Publication de produits"
          }
        },
        "redirectNote": "Vous serez redirigé vers TikTok pour autoriser la connexion. Assurez-vous d'être connecté à votre compte vendeur TikTok Shop.",
        "req1": "Un compte vendeur TikTok Shop actif",
        "req2": "La boutique doit être approuvée et en règle",
        "req3": "Vérification professionnelle effectuée",
        "reqTitle": "Prérequis :",
        "viaTitle": "Se connecter via TikTok"
      },
      "callback": {
        "processing": "Traitement...",
        "processingDetail": "Vérification de votre connexion avec la plateforme.",
        "errorTitle": "Connexion échouée",
        "error": "Connexion échouée",
        "missingParams": "Paramètres OAuth manquants. Veuillez réessayer la connexion.",
        "invalidPlatform": "Plateforme non prise en charge dans l'URL de callback.",
        "expiredState": "Lien de connexion expiré ou déjà utilisé. Veuillez réessayer.",
        "successToast": "Boutique connectée avec succès.",
        "backToConnect": "Retour à la connexion"
      },
      "placeholder": {
        "shopifyDomain": "votre-boutique.myshopify.com",
        "wooUrl": "votre-boutique.com"
      },
      "platformDescription": {
        "shopify": "Connectez votre boutique Shopify pour synchroniser les produits et les commandes",
        "etsy": "Connectez votre boutique Etsy pour synchroniser les produits et les commandes",
        "woocommerce": "Connectez votre boutique WooCommerce pour synchroniser les produits et les commandes",
        "tiktok": "Connectez votre TikTok Shop pour atteindre des millions d'acheteurs",
        "manual": "Créer une boutique manuellement — aucun compte de plateforme requis"
      },
      "backToPlatforms": "Retour aux plateformes",
      "comingSoon": "Bientôt disponible",
      "connect": "Connecter",
      "connectWith": "Se connecter avec {{name}}",
      "connectedToast": "Boutique connectée",
      "encryptedNote": "Vos identifiants sont chiffrés et stockés en toute sécurité",
      "etsy": {
        "extensionNote": "L'OAuth natif d'Etsy arrive bientôt — utilisez l'extension Chrome Printway pour importer votre boutique Etsy dès aujourd'hui.",
        "title": "Connecter Etsy"
      },
      "genericError": "Impossible de connecter la boutique. Veuillez réessayer.",
      "integrationGuide": "Guide d'intégration",
      "manual": {
        "create": "Créer une boutique",
        "feat": {
          "fulfil": {
            "subtitle": "Acheminez les commandes manuelles via la production Printway",
            "title": "Exécution unifiée"
          },
          "track": {
            "subtitle": "Enregistrez les commandes d'une boutique hors ligne / autonome",
            "title": "Saisie manuelle de commandes"
          }
        },
        "nameLabel": "Nom de la boutique",
        "namePlaceholder": "Ma boutique autonome",
        "nameRequired": "Le nom de la boutique est requis.",
        "nameTooLong": "Le nom de la boutique ne doit pas dépasser 120 caractères.",
        "subtitle": "Suivez une boutique hors ligne ou autonome par son nom. Aucune connexion à une plateforme requise.",
        "successToast": "Boutique manuelle créée.",
        "title": "Ajouter une boutique manuelle",
        "unknownError": "Impossible de créer la boutique. Veuillez réessayer."
      },
      "modalSubtitle": "Sélectionnez une plateforme pour connecter votre boutique :",
      "modalTitle": "Connecter une boutique",
      "needHelp": "Besoin d'aide ?",
      "newBadge": "Nouveau",
      "selected": "Sélectionné",
      "whatYouGet": "Ce que vous obtenez :"
    },
    "integrationGuide": {
      "backToStores": "Retour aux boutiques",
      "title": "Guide d'intégration",
      "subtitle": "Rédigez le guide de connexion étape par étape présenté aux marchands pour chaque plateforme.",
      "platformTablist": "Plateforme",
      "emptyState": "Aucune étape pour le moment. Ajoutez la première étape pour cette plateforme.",
      "stepTitlePlaceholder": "Titre de l'étape",
      "stepBodyPlaceholder": "Instructions de l'étape…",
      "deleteStep": "Supprimer l'étape",
      "addStep": "Ajouter une étape",
      "autosaveNote": "Les modifications sont enregistrées automatiquement dans ce navigateur. Connectez un point de terminaison backend pour publier les guides à tous les marchands."
    },
    "sync": {
      "orderNoPlaceholder": "#1234"
    },
    "connectCard": {
      "subtitle": "pour commencer à vendre",
      "title": "Connecter une nouvelle boutique"
    },
    "search": {
      "placeholder": "Rechercher une boutique par nom ou code…",
      "label": "Rechercher des boutiques",
      "clear": "Effacer la recherche",
      "noResults": {
        "title": "Aucune boutique trouvée",
        "subtitle": "Essayez un autre terme de recherche ou retirez des filtres."
      }
    },
    "table": {
      "col": {
        "store": "Boutique",
        "status": "Statut",
        "products": "Produits",
        "orders": "Commandes",
        "lastSync": "Dernière synchronisation"
      }
    },
    "settings": {
      "autoPush": {
        "label": "Mode d'envoi automatique",
        "help": "Délai d'attente après la synchronisation d'une commande avant son envoi automatique en production.",
        "mode": {
          "immediate": "Immédiatement",
          "30m": "Après 30 minutes",
          "1h": "Après 1 heure",
          "4h": "Après 4 heures",
          "12h": "Après 12 heures",
          "24h": "Après 24 heures",
          "48h": "Après 48 heures",
          "custom": "Délai personnalisé",
          "manual": "Manuel (envoyer chaque commande moi-même)"
        },
        "customMinutesLabel": "Délai personnalisé (minutes)",
        "customMinutesHelp": "Saisissez un délai entre 1 et {{max}} minutes (jusqu'à 72 heures).",
        "customMinutesPlaceholder": "ex. 120",
        "customMinutesSuffix": "minutes",
        "save": "Enregistrer le mode d'envoi automatique",
        "saving": "Enregistrement…",
        "success": "Paramètres d'envoi automatique mis à jour.",
        "error": "Impossible de mettre à jour les paramètres d'envoi automatique. Veuillez réessayer.",
        "errors": {
          "invalidMode": "Veuillez choisir un mode d'envoi automatique valide.",
          "customRequired": "Saisissez un délai personnalisé en minutes.",
          "customBounds": "Le délai personnalisé doit être compris entre 1 et 4320 minutes (72 heures)."
        }
      }
    }
  },
  "wallet": {
    "_comment": "Phase 6 Wave 9 Task 28 — Wallet overview surface (KPI + Credit + Spending + Low-balance alert). vg-binding: PLAN:task-28 / P6.D-64 / P6.D-71..79 / G-46 / G-47",
    "overview": {
      "nav": {
        "label": "Portefeuille"
      },
      "title": "Aperçu portefeuille",
      "kpi": {
        "balance": "Solde",
        "creditLimit": "Limite crédit",
        "creditUsed": "Crédit utilisé",
        "pendingTopups": "Recharges en attente",
        "monthlySpending": "Dépenses mensuelles"
      },
      "credit": {
        "title": "Crédit",
        "limit": "Limite",
        "used": "Utilisé",
        "outstanding": "Encours",
        "lifetimeUsed": "Total utilisé",
        "available": "Disponible",
        "expiry": "Expiration",
        "expiryWarn": "Expire dans {{days}} jours",
        "usedHigh": "Utilisé > 80%",
        "flow": {
          "explain": "Débit du solde d'abord. Si insuffisant, utilise Crédit. Solde rechargé → remboursement automatique."
        },
        "blocked": {
          "limit": "Limite crédit atteinte",
          "expired": "Crédit expiré"
        }
      },
      "spending": {
        "title": "Dépenses",
        "totalSpent": "Total dépensé",
        "averageDaily": "Moyenne quotidienne",
        "empty": "Aucune donnée de dépense.",
        "range": {
          "7d": "7 jours",
          "30d": "30 jours",
          "90d": "90 jours",
          "custom": "Personnalisé"
        },
        "category": {
          "orderCharge": "Commande",
          "topup": "Recharge",
          "refund": "Remboursement",
          "creditCharge": "Débit crédit",
          "creditRepay": "Remboursement crédit",
          "sendOut": "Envoi",
          "receiveIn": "Réception",
          "cashback": "Cashback",
          "gatewayFee": "Frais gateway"
        }
      },
      "lowBalance": {
        "title": "Solde faible",
        "message": "Solde {{balance}} — sous seuil {{threshold}}.",
        "cta": "Recharger",
        "dismiss": "Ignorer"
      },
      "action": {
        "topup": "Recharger",
        "withdraw": "Retirer",
        "transfer": "Transférer"
      },
      "tab": {
        "overview": "Aperçu",
        "transactions": "Transactions",
        "linkedAccounts": "Comptes liés",
        "bankAccounts": "Comptes bancaires",
        "topup": "Recharger",
        "withdraw": "Retirer",
        "transactionsPlaceholder": "La liste des transactions arrive en Tâche 29.",
        "linkedAccountsPlaceholder": "Comptes liés en Tâche 31.",
        "bankAccountsPlaceholder": "Comptes bancaires en Tâche 31.",
        "navHint": "Sélectionnez un onglet ci-dessus pour voir les détails."
      }
    },
    "topup": {
      "_comment": "Phase 6 Wave 9 Task 29 — Wallet topup. vg-binding: PLAN:task-29 / P6.D-66 / P6.D-67 / P6.D-68 / P6.D-234 / P6.D-244 / G-48",
      "title": "Recharger",
      "confirm": "Confirmer",
      "type": {
        "instant": {
          "label": "Instantané",
          "desc": "Fonds disponibles immédiatement"
        },
        "manual": {
          "label": "Manuel",
          "desc": "Virement + preuve"
        }
      },
      "gateway": {
        "label": "Passerelle",
        "paypal": "PayPal",
        "stripe": "Stripe",
        "payoneer": "Payoneer",
        "lianlianGlobal": "LianLian Global",
        "bankTransfer": "Virement bancaire",
        "pingpong": "Pingpong",
        "sunrate": "Sunrate",
        "worldfirst": "Worldfirst",
        "airwallex": "Airwallex"
      },
      "amount": {
        "label": "Montant",
        "invalid": "Montant invalide"
      },
      "fee": {
        "preview": "Frais : {{fee}} ({{rate}}%)"
      },
      "dualMode": {
        "toggleLabel": "Mode",
        "feeCompare": "Frais Instant {{instant}}% / Manuel {{manual}}%"
      },
      "manual": {
        "step": {
          "amount": "Montant",
          "invoice": "Facture",
          "proof": "Preuve"
        },
        "payee": {
          "bankName": "Nom de la banque",
          "accountName": "Nom du compte",
          "accountNumber": "Numéro de compte",
          "swift": "SWIFT",
          "reference": "Référence",
          "address": "Adresse",
          "missing": "Coordonnées du bénéficiaire indisponibles pour ce gateway — contactez le support avant tout virement."
        },
        "invoice": {
          "download": "Télécharger facture",
          "unavailable": "La facture de pré-paiement (PDF) n'est pas encore disponible pour les recharges manuelles — effectuez le virement avec les coordonnées ci-dessus."
        },
        "proof": {
          "upload": "Téléverser preuve",
          "uploaded": "Téléversé — en attente",
          "missing": "Veuillez choisir un fichier"
        }
      },
      "history": {
        "title": "Historique",
        "empty": "Aucune recharge",
        "column": {
          "createdAt": "Date",
          "gateway": "Passerelle",
          "mode": "Mode",
          "amount": "Montant",
          "status": "Statut",
          "proof": "Preuve",
          "action": "Action"
        },
        "status": {
          "pending": "En attente",
          "processing": "En cours",
          "completed": "Terminé",
          "failed": "Échoué",
          "cancelled": "Annulé"
        },
        "action": {
          "cancel": "Annuler",
          "retry": "Réessayer",
          "viewProof": "Voir preuve",
          "viewReceipt": "Reçu"
        }
      },
      "sdk": {
        "paypalPlaceholder": "Le SDK PayPal Smart Buttons se charge ici",
        "stripePlaceholder": "Le formulaire Stripe Elements se charge ici"
      }
    },
    "transactions": {
      "_comment": "Phase 6 Wave 9 Task 30 — Registre des transactions du portefeuille (9 types selon P6.D-65 + P6.D-233 frais gateway). vg-binding: PLAN:task-30 / P6.D-65 / P6.D-233 / G-49",
      "tabs": {
        "transaction": "Transactions",
        "orderTransaction": "Transactions par commande"
      },
      "orderTx": {
        "order": "Commande",
        "txId": "ID transaction",
        "amount": "Montant",
        "surcharge": "Surtaxe",
        "kind": "Type",
        "date": "Date",
        "method": "Méthode",
        "note": "Note",
        "search": "Rechercher par code commande / ID transaction",
        "searchPlaceholder": "Code commande ou ID transaction…",
        "noMatch": "Aucune transaction ne correspond",
        "empty": "Aucune transaction par commande"
      },
      "child": {
        "type": {
          "charge": "Débit",
          "refund": "Remboursement",
          "surcharge": "Surtaxe"
        }
      },
      "title": "Transactions",
      "subtitle": "9 types de transactions — registre",
      "empty": "Aucune transaction",
      "totalCount": "{{count}} transactions",
      "type": {
        "orderCharge": "Commande",
        "topup": "Recharge",
        "refund": "Remboursement",
        "creditCharge": "Débit crédit",
        "creditRepay": "Remboursement crédit",
        "sendOut": "Envoi",
        "receiveIn": "Réception",
        "cashback": "Cashback",
        "gatewayFee": "Frais gateway"
      },
      "column": {
        "id": "ID transaction",
        "ts": "Heure",
        "type": "Type",
        "method": "Méthode",
        "description": "Description",
        "note": "Note",
        "amount": "Montant",
        "balance": "Solde après",
        "action": "Action",
        "status": "Statut"
      },
      "method": {
        "wallet": "Portefeuille",
        "credit": "Crédit",
        "bank": "Banque",
        "paypal": "PayPal",
        "payoneer": "Payoneer",
        "stripe": "Stripe"
      },
      "filter": {
        "fromDate": "Du",
        "toDate": "Au",
        "status": "Statut",
        "allTypes": "Tous types",
        "allStatuses": "Tous statuts",
        "searchId": "ID transaction",
        "searchIdPlaceholder": "Saisir l'ID de transaction…",
        "allMethods": "Toutes les méthodes",
        "custom": "Personnalisé",
        "dateRange": "Plage de dates",
        "last30d": "30 derniers jours",
        "last7d": "7 derniers jours",
        "search": "Rechercher une note",
        "searchPlaceholder": "Rechercher…",
        "today": "Aujourd'hui",
        "method": "Moyen de paiement"
      },
      "status": {
        "pending": "En attente",
        "completed": "Terminé",
        "failed": "Échoué"
      },
      "action": {
        "viewReceipt": "Voir reçu",
        "receiptError": "Téléchargement du reçu impossible"
      },
      "detail": {
        "gateway": "Passerelle",
        "reference": "Référence"
      },
      "export": {
        "csv": "CSV",
        "excel": "Excel",
        "error": "Échec de l'export"
      },
      "perPage": "Par page",
      "showing": "Affichage de {{from}} à {{to}} sur {{total}}",
      "showingPage": "Affichage de {{from}} à {{to}}",
      "pageLabel": "Page {{page}}",
      "sort": {
        "createdAt": "Trier par date",
        "label": "Date",
        "asc": "↑",
        "desc": "↓"
      },
      "children": {
        "error": "Impossible de charger les détails de la commande. Veuillez réessayer.",
        "empty": "Aucune commande dans cette transaction."
      },
      "grouped": {
        "orderCount": "${row.orderCount} commandes",
        "label_one": "Paiement de {{count}} commande(s)",
        "label_other": "Paiement de {{count}} commande(s)",
        "orderCount_one": "{{count}} commande",
        "orderCount_other": "{{count}} commandes",
        "label": "Payer {{count}} commandes"
      },
      "error": "Impossible de charger l'historique des transactions. Veuillez réessayer."
    },
    "send": {
      "_comment": "Phase 6 Wave 9 Task 30 — Assistant Envoi de solde (P6.D-69). vg-binding: PLAN:task-30 / P6.D-69 / G-49",
      "title": "Envoyer un solde",
      "confirm": "Confirmer",
      "feeFree": "Gratuit entre marchands Printway — sans frais.",
      "success": "Envoi réussi",
      "recent": "Récents",
      "noRecipients": "Vous n'appartenez à aucun groupe de transfert. Demandez à un administrateur de vous en ajouter un.",
      "step": {
        "recipient": "Destinataire",
        "confirm": "Confirmer",
        "amount": "Montant",
        "verify": "Vérifier"
      },
      "recipient": {
        "label": "Email du destinataire",
        "pickLabel": "Destinataire (membres du groupe de transfert)",
        "placeholder": "Choisir un destinataire…"
      },
      "amount": {
        "label": "Montant",
        "available": "Disponible : {{amount}}"
      },
      "note": {
        "label": "Note (optionnelle)"
      },
      "error": {
        "selfSend": "Impossible d'envoyer à soi-même",
        "emailRequired": "Email du destinataire requis",
        "notFound": "Destinataire introuvable",
        "invalidAmount": "Montant invalide",
        "pickRecipient": "Veuillez choisir un destinataire",
        "generic": "Échec de l'envoi",
        "insufficientBalance": "Le montant dépasse votre solde disponible",
        "amountOutOfRange": "Le montant est hors des limites du groupe de transfert",
        "limitExceeded": "Limite de transfert mensuelle dépassée",
        "recipientIneligible": "Le destinataire n’est pas éligible aux transferts",
        "walletFrozen": "Votre portefeuille est gelé — transferts bloqués"
      }
    },
    "withdraw": {
      "_comment": "Phase 6 Wave 9 Task 30 — Page + modal Retrait. vg-binding: PLAN:task-30 / G-50",
      "title": "Retirer",
      "subtitle": "Demander un virement du portefeuille vers un compte bancaire",
      "bankAccount": "Compte bancaire",
      "amount": "Montant",
      "feePreview": "Frais",
      "netAmount": "Montant net",
      "estimatedArrival": "Arrivée estimée",
      "confirm": "Confirmer le retrait",
      "request": "Demander un retrait",
      "availableBalance": "Solde disponible",
      "empty": "Aucun compte bancaire vérifié. Ajoutez-en un dans les Réglages.",
      "success": "Retrait soumis",
      "successWithEta": "Retrait soumis — arrivée estimée {{eta}}",
      "error": {
        "exceedsBalance": "Montant supérieur au solde disponible",
        "noAccount": "Sélectionnez un compte",
        "generic": "Échec du retrait"
      }
    },
    "transfer": {
      "_comment": "Phase 6 Wave 9 Task 30 — Modal Transfert entre comptes liés. vg-binding: PLAN:task-30 / G-50",
      "title": "Transfert",
      "from": "De",
      "to": "Vers",
      "amount": "Montant",
      "confirm": "Confirmer le transfert",
      "selectAccount": "Choisir un compte",
      "error": {
        "required": "Choisissez les comptes source et destination",
        "sameAccount": "Source et destination doivent différer",
        "invalidAmount": "Montant invalide",
        "generic": "Échec du transfert"
      }
    },
    "twoFA": {
      "_comment": "Phase 6 Wave 9 Task 30 — Vérification 2FA partagée par Envoi + Retrait + Transfert. vg-binding: PLAN:task-30 / P6.D-69",
      "title": "Vérifier 2FA",
      "code": "Code à 6 chiffres",
      "verify": "Vérifier",
      "error": "Code invalide"
    },
    "linkedAccounts": {
      "_comment": "Phase 6 Wave 9 Task 31 — Gestion des comptes liés (liste rapide pour Envoi). vg-binding: PLAN:task-31 / P6.D-69 / G-51",
      "title": "Comptes liés",
      "subtitle": "Liste rapide des marchands Printway pour vos envois.",
      "add": "Ajouter",
      "empty": "Aucun compte lié",
      "deleteConfirm": "Supprimer le lien avec {{email}} ?",
      "deleteSuccess": "Compte lié supprimé",
      "deleteError": "Échec de la suppression",
      "addSuccess": "Compte lié ajouté",
      "modal": {
        "email": "E-mail destinataire",
        "lookup": {
          "match": "Trouvé : {{name}}",
          "notFound": "Utilisateur introuvable"
        },
        "errorEmailRequired": "E-mail requis",
        "errorSelfLink": "Auto-lien impossible",
        "errorGeneric": "Échec de la liaison",
        "add": "Ajouter"
      }
    },
    "bankAccounts": {
      "_comment": "Phase 6 Wave 9 Task 31 — Gestion des comptes bancaires pour retraits. vg-binding: PLAN:task-31 / P6.D-69 / G-51",
      "title": "Comptes bancaires",
      "subtitle": "Comptes bancaires vérifiés disponibles pour retrait.",
      "add": "Ajouter un compte",
      "empty": "Aucun compte",
      "verified": "Vérifié",
      "notVerified": "Non vérifié",
      "deleteConfirm": "Supprimer ce compte ?",
      "deleteSuccess": "Compte bancaire supprimé",
      "deleteError": "Échec de la suppression",
      "addSuccessWithMask": "Compte ajouté {{mask}}",
      "field": {
        "bankName": "Nom de la banque",
        "accountName": "Titulaire",
        "accountNumber": "Numéro de compte",
        "accountType": "Type de compte",
        "routingNumber": "Numéro de routage",
        "country": "Pays",
        "swift": "SWIFT / BIC",
        "iban": "IBAN",
        "address": "Adresse du marchand",
        "addressStreet": "Adresse (rue)",
        "addressCity": "Ville",
        "addressState": "État / Province",
        "addressZip": "Code postal"
      },
      "accountType": {
        "checking": "Compte courant",
        "savings": "Compte épargne"
      },
      "country": {
        "US": "États-Unis",
        "VN": "Vietnam",
        "GB": "Royaume-Uni",
        "FR": "France",
        "DE": "Allemagne",
        "CN": "Chine",
        "JP": "Japon",
        "AU": "Australie",
        "CA": "Canada",
        "SG": "Singapour"
      },
      "modal": {
        "step": {
          "form": "Détails",
          "twoFA": "Vérifier 2FA"
        },
        "errorRequired": "Veuillez remplir les champs requis",
        "errorGeneric": "Échec de l'ajout",
        "add": "Ajouter le compte"
      }
    },
    "pageTab": {
      "aria": "Sections du portefeuille",
      "overview": "Aperçu",
      "billing": "Facturation",
      "invoices": "Factures",
      "transactions": "Transactions",
      "paymentMethods": "Moyens de paiement",
      "billingSettings": "Paramètres de facturation",
      "paymentRequests": "Demandes de paiement"
    },
    "recent": {
      "cancelError": "Annulation impossible — veuillez réessayer.",
      "title": "Transactions récentes",
      "viewAll": "Tout voir →",
      "loading": "Chargement…",
      "empty": "Aucune transaction pour l'instant. Créez un topup ou un withdraw pour commencer.",
      "cancel": "Annuler",
      "col": {
        "description": "Description",
        "date": "Date",
        "amount": "Montant",
        "balanceAfter": "Solde après",
        "method": "Méthode"
      },
      "pending": "En attente"
    },
    "tx": {
      "orderCharge": "Paiement de {{count}} commandes",
      "orderRefund": "Remboursement de {{count}} commandes",
      "transferIn": "Reçu d'un marchand",
      "transferOut": "Envoyé à un marchand"
    }
  },
  "billing": {
    "_comment": "Phase 6 Wave 10 Task 32 — Billing standalone Finance entry. vg-binding: PLAN:task-32 / P6.D-01 / P6.D-245 / P6.D-247",
    "nav": {
      "label": "Facturation"
    },
    "overview": {
      "title": "Aperçu facturation",
      "kpi": {
        "outstanding": "Encours",
        "dueSoon": "Bientôt dû",
        "overdue": "En retard"
      },
      "link": {
        "invoices": "Factures",
        "addresses": "Adresses de facturation",
        "paymentHistory": "Historique paiements",
        "statements": "Relevés",
        "paymentMethods": "Modes de paiement"
      },
      "cta": {
        "create": "Créer facture"
      },
      "mode": {
        "prepaid": {
          "subtext": "Mode Prépayé — factures de rapport seulement."
        },
        "credit": {
          "subtext": "Mode Crédit — factures de rapport."
        },
        "invoice": {
          "subtext": "Mode Facture — payez à temps."
        }
      },
      "preview": {
        "viewAll": "Tout voir →",
        "empty": "Aucun enregistrement.",
        "statementSub": "Frais {{charges}} · Paiements {{payments}}",
        "default": "Par défaut"
      }
    },
    "list": {
      "title": "Factures",
      "column": {
        "invoiceNumber": "N° facture",
        "status": "Statut",
        "issueDate": "Date d'émission",
        "dueDate": "Échéance",
        "amount": "Montant",
        "actions": "Actions"
      },
      "filter": {
        "status": "Statut",
        "all": "Tout",
        "draft": "Brouillon",
        "pending": "En attente",
        "paid": "Payée",
        "overdue": "En retard",
        "cancelled": "Annulée",
        "dateRange": "Période de facturation",
        "dateRangeHint": "Filtre sur la période couverte par la facture, pas sur sa date d'émission.",
        "dateRangePlaceholder": "Date de début – Date de fin"
      },
      "action": {
        "view": "Voir",
        "pay": "Payer"
      },
      "empty": "Aucune facture"
    },
    "status": {
      "draft": "Brouillon",
      "pending": "En attente",
      "paid": "Payée",
      "overdue": "En retard",
      "cancelled": "Annulée",
      "dueSoon": "Bientôt dû"
    },
    "create": {
      "_comment": "Phase 6 Wave 10 Task 33 — Invoice CREATE page. vg-binding: PLAN:task-33 / P6.D-245",
      "title": "Créer facture",
      "field": {
        "customer": {
          "label": "Client",
          "placeholder": "Nom du client"
        },
        "issueDate": "Date d'émission",
        "dueDate": "Échéance",
        "lineItem": {
          "description": "Description",
          "qty": "Qté",
          "unitPrice": "Prix unitaire",
          "lineTotal": "Total ligne"
        },
        "notes": "Notes",
        "terms": "Conditions",
        "taxRate": "Taxe (%)",
        "email": "E-mail"
      },
      "terms": {
        "net7": "Net 7",
        "net15": "Net 15",
        "net30": "Net 30",
        "net60": "Net 60",
        "custom": "Personnalisée",
        "customPlaceholder": "Conditions personnalisées"
      },
      "lineItems": {
        "add": "Ajouter ligne"
      },
      "section": {
        "lineItems": "Lignes"
      },
      "subtotal": "Sous-total",
      "creditApplied": "Crédit appliqué",
      "tax": "Taxe",
      "total": "Total",
      "submit": "Créer",
      "submitting": "Création...",
      "error": {
        "noLineItems": "Ajoutez au moins une ligne",
        "generic": "Échec de création de la facture"
      }
    },
    "detail": {
      "_comment": "Phase 6 Wave 10 Task 33 — Invoice DETAIL page. vg-binding: PLAN:task-33 / P6.D-245",
      "title": "Détail facture",
      "empty": "Facture introuvable",
      "action": {
        "pay": "Payer",
        "downloadPdf": {
          "label": "Télécharger le PDF",
          "loading": "Téléchargement..."
        },
        "downloadPdfLoading": "Téléchargement...",
        "viewCustomer": "Voir client",
        "dispute": {
          "label": "Contester cette facture",
          "loading": "Ouverture du litige..."
        }
      },
      "section": {
        "customer": "Client",
        "dates": "Émission / Échéance",
        "lineItems": "Lignes",
        "totals": "Totaux",
        "notes": "Notes",
        "payments": "Historique paiements"
      },
      "lineItems": {
        "empty": "Aucune ligne"
      },
      "payments": {
        "empty": "Aucun paiement"
      },
      "pdf": {
        "notReadyTitle": "PDF non prêt",
        "notReady": "Le PDF de la facture est en cours de génération. Réessayez bientôt."
      },
      "dispute": {
        "subject": "Litige de facture : #{{invoiceNumber}}",
        "body": "Le marchand a ouvert un litige pour la facture #{{invoiceNumber}}. Veuillez vérifier les frais et répondre.",
        "errorTitle": "Impossible d’ouvrir le litige",
        "error": "Échec de la création du ticket de litige. Veuillez réessayer."
      }
    },
    "pay": {
      "_comment": "Phase 6 Wave 10 Task 33 — Invoice PAYMENT page. vg-binding: PLAN:task-33 / P6.D-241 / P6.D-245",
      "title": "Payer facture",
      "summary": "Facture #{{number}} — Total {{amount}}",
      "confirm": "Confirmer",
      "processing": "Traitement...",
      "success": "Paiement réussi",
      "error": "Échec",
      "alreadyPaid": "Cette facture est déjà réglée — aucun montant supplémentaire n’a été débité. Si votre banque affiche une pré-autorisation, elle disparaîtra d’elle-même.",
      "changed": "Cette facture a changé pendant le paiement — rien n’a été débité. Vérifiez-la et réessayez."
    },
    "paymentHistory": {
      "_comment": "Phase 6 Wave 10 Task 33 — Payment history page. vg-binding: PLAN:task-33 / P6.D-245",
      "title": "Historique",
      "empty": "Aucun paiement",
      "filter": {
        "from": "Du",
        "to": "Au",
        "method": {
          "label": "Méthode",
          "all": "Tout",
          "wallet": "Portefeuille",
          "stripe": "Stripe",
          "paypal": "PayPal",
          "bankTransfer": "Virement"
        }
      },
      "column": {
        "ts": "Horodatage",
        "invoice": "Facture",
        "method": "Méthode",
        "amount": "Montant",
        "status": "Statut",
        "reference": "Référence",
        "action": "Action"
      },
      "status": {
        "success": "Succès",
        "pending": "En attente",
        "failed": "Échouée"
      },
      "action": {
        "viewReceipt": "Voir reçu"
      }
    },
    "statements": {
      "_comment": "Phase 6 Wave 10 Task 33 — Statements page. vg-binding: PLAN:task-33 / P6.D-70",
      "title": "Relevés",
      "empty": "Aucun relevé pour cette période",
      "period": {
        "label": "Période",
        "daily": "Quotidien",
        "weekly": "Hebdomadaire",
        "monthly": "Mensuel",
        "custom": "Personnalisée"
      },
      "column": {
        "periodStart": "Début période",
        "periodEnd": "Fin période",
        "totalCharges": "Frais",
        "totalPayments": "Paiements",
        "balance": "Solde",
        "breakdown": "Répartition par catégorie"
      },
      "chart": {
        "title": "Frais vs paiements"
      },
      "legend": {
        "charges": "Frais",
        "payments": "Paiements"
      },
      "table": {
        "title": "Relevés"
      },
      "download": "Télécharger",
      "noData": "Aucune donnée.",
      "breakdownEmpty": "Aucune dépense par catégorie sur cette période"
    },
    "paymentMethods": {
      "_comment": "Phase 6 Wave 10 Task 34 — Payment methods management. vg-binding: PLAN:task-34 / P6.D-66 / G-56",
      "title": "Modes de paiement",
      "add": "Ajouter un moyen",
      "empty": "Aucun moyen enregistré",
      "default": "Défaut",
      "setDefault": "Définir par défaut",
      "deleteConfirm": "Supprimer ce moyen ?",
      "last4": "•••• {{last4}}",
      "expiry": "Expire {{month}}/{{year}}",
      "addSuccess": "Moyen ajouté",
      "deleteSuccess": "Moyen supprimé",
      "deleteError": "Échec de la suppression",
      "setDefaultSuccess": "Défaut mis à jour",
      "setDefaultError": "Impossible de définir le défaut",
      "brand": {
        "visa": "Visa",
        "mastercard": "Mastercard",
        "amex": "Amex",
        "paypal": "PayPal",
        "card": "Carte"
      },
      "modal": {
        "subtitle": "Choisissez un fournisseur et saisissez les informations",
        "tabsLabel": "Fournisseur",
        "tabs": {
          "stripe": "Carte de crédit (Stripe)",
          "paypal": "PayPal"
        },
        "cardNumber": "Numéro de carte",
        "expDate": "Expiration",
        "cvc": "CVC",
        "holderName": "Titulaire",
        "billingZip": "Code postal",
        "save": "Enregistrer",
        "connectPaypal": "Connecter PayPal",
        "setDefault": "Définir par défaut",
        "paypalSubtitle": "Connectez votre compte PayPal via OAuth pour payer les factures.",
        "error": {
          "required": "Veuillez remplir tous les champs de la carte",
          "generic": "Impossible d'ajouter le moyen de paiement",
          "cardDeclined": "Votre carte a été refusée. Veuillez essayer une autre carte.",
          "insufficientFunds": "Votre carte ne dispose pas de fonds suffisants.",
          "incorrectCvc": "Le code de sécurité de votre carte est incorrect.",
          "expiredCard": "Votre carte a expiré.",
          "processingError": "Une erreur s'est produite lors du traitement de votre carte. Veuillez réessayer.",
          "incompleteCard": "Veuillez compléter toutes les informations de la carte.",
          "authFailed": "L'authentification de la carte a échoué. Veuillez réessayer.",
          "notConfigured": "Le paiement par carte n’est pas activé sur cette plateforme.",
          "network": "Impossible de joindre le prestataire de paiement. Veuillez réessayer.",
          "duplicate": "Cette carte a déjà été ajoutée."
        },
        "cardLoading": "Chargement du formulaire de carte sécurisé…",
        "cardUnavailable": "Le paiement par carte n'est pas disponible pour le moment. Contactez le support ou utilisez PayPal.",
        "terms": "Votre carte est stockée en toute sécurité par Stripe et servira à régler vos futures factures. Vous pouvez la retirer à tout moment."
      }
    },
    "fulfillmentReports": {
      "_comment": "Phase 6 Wave 10 Task 34 — Fulfillment reports list + generate. vg-binding: PLAN:task-34 / P6.D-66 / G-56",
      "title": "Rapports d'exécution",
      "generate": "Générer rapport",
      "empty": "Aucun rapport pour l'instant",
      "column": {
        "period": "Période",
        "totalOrders": "Commandes exécutées",
        "totalRevenue": "Revenu",
        "status": "Statut",
        "generatedAt": "Généré le",
        "download": "Télécharger"
      },
      "status": {
        "generating": "Génération",
        "ready": "Prêt",
        "failed": "Échec"
      },
      "download": {
        "pdf": "PDF",
        "csv": "CSV"
      },
      "generate.title": "Générer rapport",
      "generate.period.label": "Période",
      "generate.period.last7d": "7 derniers jours",
      "generate.period.last30d": "30 derniers jours",
      "generate.period.last90d": "90 derniers jours",
      "generate.period.custom": "Personnalisé",
      "generate.storeFilter": "Filtrer par boutique (ids séparés par des virgules)",
      "generate.categoryFilter": "Filtrer par catégorie (ids séparés par des virgules)",
      "generate.submit": "Générer",
      "generate.processing": "Génération... ({{pct}}%)",
      "generate.error.dateRequired": "Sélectionnez les dates de début et de fin",
      "generate.error.generic": "Impossible de générer le rapport"
    }
  },
  "settings": {
    "_comment": "Phase 6 Wave 11 Task 35 — Paramètres (Profil + Général + Activité). vg-binding: PLAN:task-35 / P6.D-122 / P6.D-123 / P6.D-131 / P6.D-132 / P6.D-221 / P6.D-249 / G-57 / G-69",
    "nav": {
      "label": "Paramètres"
    },
    "savedAt": "Enregistré à {{ts}}",
    "tab": {
      "profile": "Profil",
      "security": "Sécurité",
      "notifications": "Notifications",
      "preferences": "Préférences",
      "activity": "Activité",
      "general": "Général",
      "team": "Équipe",
      "branding": "Marque",
      "apiKeys": "Clés API",
      "connections": "Connexions",
      "security.placeholder": "Paramètres de sécurité — bientôt disponibles.",
      "notifications.placeholder": "Paramètres de notifications — bientôt disponibles.",
      "preferences.placeholder": "Paramètres de préférences — bientôt disponibles."
    },
    "profile": {
      "title": "Profil",
      "avatar": "Téléverser l'avatar",
      "name": "Nom",
      "email": "Email",
      "email.readonly": "Contactez le Support pour changer votre email.",
      "phone": "Téléphone",
      "timezone": "Fuseau horaire",
      "language": "Langue",
      "save": "Enregistrer",
      "address": {
        "address": "Adresse",
        "city": "Ville/Arrondissement",
        "country": "Pays",
        "countryPlaceholder": "Sélectionnez un pays",
        "helper": "Cette adresse sera utilisée pour les factures, les demandes de paiement et les documents associés.",
        "state": "État/Province",
        "statePlaceholder": "Sélectionnez un état/une province",
        "title": "Informations d'adresse",
        "zip": "Code postal",
        "fieldAddress": "Adresse",
        "fieldCity": "Ville",
        "fieldZip": "Code postal",
        "fieldCountry": "Pays",
        "incomplete": "Pour enregistrer votre adresse, veuillez aussi remplir : {{fields}}."
      },
      "dob": "Date de naissance",
      "fullName": "Nom complet",
      "gender": {
        "female": "Femme",
        "label": "Sexe",
        "male": "Homme",
        "other": "Autre",
        "preferNot": "Je préfère ne pas répondre"
      },
      "phoneDial": "Indicatif pays",
      "saveChanges": "Enregistrer les modifications"
    },
    "general": {
      "title": "Paramètres généraux",
      "billingInfo": "Informations de facturation",
      "billingInfo.subtitle": "Utilisées sur les factures, reçus et documents fiscaux.",
      "billingInfo.legalName": "Raison sociale",
      "billingInfo.taxId": "Numéro fiscal",
      "billingInfo.addressLine1": "Adresse ligne 1",
      "billingInfo.addressLine2": "Adresse ligne 2",
      "billingInfo.city": "Ville",
      "billingInfo.state": "État / Région",
      "billingInfo.postalCode": "Code postal",
      "billingInfo.country": "Pays",
      "billingMode": "Mode de facturation",
      "billingMode.adminControlled": "Le mode de facturation est défini par Admin Support. Contactez-nous pour le modifier.",
      "billingMode.prepaid.label": "Prépayé",
      "billingMode.prepaid.explain": "Portefeuille prépayé, pas de factures à régler",
      "billingMode.credit.label": "Crédit",
      "billingMode.credit.explain": "Imputation sur la limite de crédit",
      "billingMode.invoice.label": "Facture",
      "billingMode.invoice.explain": "Payez les factures selon l'échéancier",
      "preferences": "Préférences",
      "preferences.subtitle": "Thème, densité et langue d'affichage."
    },
    "preferences": {
      "theme": "Thème",
      "theme.light": "Clair",
      "theme.dark": "Sombre",
      "theme.system": "Système",
      "density": "Densité",
      "density.compact": "Compact",
      "density.normal": "Normal",
      "currency": {
        "usd": "Dollar américain",
        "vnd": "Dong vietnamien",
        "eur": "Euro",
        "gbp": "Livre sterling",
        "aud": "Dollar australien",
        "cad": "Dollar canadien",
        "jpy": "Yen japonais",
        "cny": "Yuan chinois"
      }
    },
    "activity": {
      "title": "Activité récente",
      "empty": "Aucune activité récente.",
      "ipPrefix": "IP :",
      "loadMore": "Charger plus d'activité",
      "subtitle": "Activités récentes et historique de connexion de votre compte"
    },
    "security": {
      "_comment": "Phase 6 Wave 11 Task 36 — Sécurité (Mot de passe + 2FA + Sessions + Historique). vg-binding: PLAN:task-36 / P6.D-124..130 / G-58 / G-59",
      "title": "Sécurité",
      "openLink": "Ouvrir",
      "forgotPassword": "Mot de passe oublié ?",
      "devices": {
        "title": "Appareils et historique"
      },
      "password": {
        "change": "Modifier le mot de passe",
        "current": "Mot de passe actuel",
        "new": "Nouveau mot de passe",
        "confirm": "Confirmer le nouveau mot de passe",
        "submit": "Mettre à jour le mot de passe",
        "tooShort": "Minimum 8 caractères.",
        "mismatch": "Les mots de passe ne correspondent pas.",
        "changedRedirect": "Mot de passe modifié. Redirection vers la connexion…",
        "strength": {
          "weak": "Faible",
          "medium": "Moyen",
          "strong": "Fort"
        },
        "show": "Afficher le mot de passe",
        "hide": "Masquer le mot de passe",
        "currentWrong": "Le mot de passe actuel est incorrect.",
        "sameAsCurrent": "Le nouveau mot de passe doit être différent de l'ancien.",
        "matched": "Les mots de passe correspondent.",
        "success": "Mot de passe modifié avec succès. Vos autres sessions ont été déconnectées.",
        "title": "Changer le mot de passe"
      },
      "2fa": {
        "label": "Authentification à deux facteurs",
        "subtitle": "Ajoutez un second facteur (application d'authentification) pour protéger les connexions et les actions sensibles.",
        "enabled": "Activé",
        "disabled": "Désactivé",
        "setup": "Activer 2FA",
        "disable": "Désactiver 2FA",
        "disableConfirm": "Saisissez le mot de passe de votre compte pour désactiver l'authentification à deux facteurs.",
        "scanQr": "Scannez le QR avec votre application d'authentification",
        "qrAlt": "QR code d'enrôlement 2FA",
        "manualKey": "Ou saisissez cette clé manuellement",
        "codeLabel": "Code à 6 chiffres",
        "verify": "Vérifier et activer",
        "enabledSuccess": "L'authentification à deux facteurs est maintenant activée sur votre compte.",
        "recoveryCodes": {
          "title": "Codes de récupération",
          "warn": "Enregistrez ces codes maintenant — ils ne sont affichés qu’une seule fois. Chaque code est à usage unique si vous perdez votre application d’authentification.",
          "download": "Télécharger en TXT",
          "unavailable": "Aucun code de récupération n'a été émis. Contactez le Support si nécessaire.",
          "savedAck": "J'ai enregistré ces codes"
        },
        "qrUnavailable": "QR indisponible",
        "codePlaceholder": "Saisissez le code à 6 chiffres de votre application",
        "enable": "Activer la 2FA",
        "manualCode": "Code de saisie manuelle :",
        "setupHint": "Scannez ce QR code avec n'importe quelle application d'authentification (Google Authenticator, Authy, Microsoft Authenticator, etc.)",
        "setupTitle": "Configurer l'authentification à deux facteurs",
        "tagline": "Ajoutez une couche de sécurité supplémentaire à votre compte",
        "verifyEnable": "Vérifier et activer",
        "codeHint": "Le code change toutes les 30 secondes. Saisissez le code affiché dans Google Authenticator au moment où vous cliquez sur Verify (n'utilisez pas un ancien code).",
        "passwordLabel": "Mot de passe du compte",
        "passwordTooShort": "Saisissez le mot de passe de votre compte (au moins 8 caractères)."
      }
    },
    "sessions": {
      "_comment": "Phase 6 Wave 11 Task 36 — Sessions actives. vg-binding: PLAN:task-36 / P6.D-126 / G-58",
      "title": "Sessions actives",
      "subtitle": "Appareils actuellement connectés à votre compte. Révoquez toute session que vous ne reconnaissez pas.",
      "current": "Actuelle",
      "revoke": "Révoquer",
      "revokeAll": "Révoquer toutes les autres sessions",
      "revokeAllConfirm": "Se déconnecter de tous les autres appareils ? Votre session actuelle est conservée.",
      "empty": "Aucune session active.",
      "column": {
        "device": "Appareil",
        "ip": "Adresse IP",
        "location": "Emplacement",
        "lastActive": "Dernière activité"
      },
      "activeNow": "Actif maintenant",
      "signOut": "Se déconnecter",
      "signOutAll": "Déconnecter toutes les autres sessions"
    },
    "loginHistory": {
      "_comment": "Phase 6 Wave 11 Task 36 — Historique de connexion. vg-binding: PLAN:task-36 / P6.D-127 / G-58 / G-59",
      "title": "Historique de connexion",
      "subtitle": "Tentatives de connexion récentes (réussies et échouées) sur votre compte.",
      "empty": "Aucune tentative de connexion sur cette plage.",
      "filter": {
        "from": "Du",
        "to": "Au"
      },
      "column": {
        "ts": "Date",
        "ip": "Adresse IP",
        "location": "Emplacement",
        "device": "Appareil",
        "browser": "Navigateur",
        "status": "Statut",
        "reason": "Raison"
      },
      "status": {
        "all": "Tous",
        "success": "Succès",
        "failed": "Échec"
      }
    },
    "impersonate": {
      "_comment": "Phase 6 Wave 11 Task 36 — Bannière impersonation admin. vg-binding: PLAN:task-36 / P6.D-128 / P6.D-130",
      "banner": "Connecté en tant que {{merchant}} (Admin {{admin}})",
      "stop": "Arrêter l'impersonation"
    },
    "team": {
      "_comment": "Phase 6 Wave 11 Task 37 — Membres de l'équipe + suspendre/désactiver/réactiver + budget. vg-binding: PLAN:task-37 / P6.D-80..D-91 / G-60 / G-61",
      "title": "Membres de l'équipe",
      "subtitle": "Invitez vos coéquipiers et contrôlez leurs accès et dépenses.",
      "create": {
        "label": "Inviter un membre de l'équipe",
        "description": "Créez une invitation d'équipe en attente avec rôle et limites de dépenses."
      },
      "empty": "Aucun membre pour le moment.",
      "search": {
        "label": "Recherche",
        "placeholder": "Rechercher par nom ou email…"
      },
      "filter": {
        "allRoles": "Tous les rôles",
        "allStatus": "Tous les statuts"
      },
      "footer": {
        "count": "{{count}} membre(s)"
      },
      "tab": {
        "profile": "Profil",
        "permissions": "Permissions",
        "budget": "Budget",
        "activity": "Activité"
      },
      "role": {
        "admin": "Administrateur",
        "admin.desc": "Accès complet — facturation, équipe, tous les paramètres.",
        "manager": "Responsable",
        "manager.desc": "Opérations + finances, sans paramètres équipe ou facturation.",
        "staff": "Collaborateur",
        "staff.desc": "Travail quotidien commandes + produits, finance limitée.",
        "viewer": "Observateur",
        "viewer.desc": "Lecture seule — tableaux de bord, commandes et rapports."
      },
      "status": {
        "active": "Actif",
        "suspended": "Suspendu",
        "deactivated": "Désactivé",
        "pending": "Invitation en attente"
      },
      "column": {
        "avatar": "Avatar",
        "name": "Membre",
        "email": "Email",
        "role": "Rôle",
        "status": "Statut",
        "lastLogin": "Dernière connexion",
        "budget": "Budget",
        "orderLimit": "Limite commande",
        "actions": "Actions"
      },
      "form": {
        "field": {
          "name": "Nom",
          "email": "Email",
          "role": "Rôle",
          "monthlyBudget": "Budget mensuel (USD)",
          "orderLimit": "Limite par commande (USD)",
          "sendInvite": "Envoyer l'email d'activation maintenant"
        },
        "budget": {
          "help": "Plafond mensuel (USD). Vide = illimité."
        }
      },
      "action": {
        "suspend": {
          "title": "Suspendre le compte",
          "warn": "L'utilisateur ne peut pas se connecter.",
          "description": "Confirmez une suspension réversible et indiquez le motif d'audit."
        },
        "deactivate": {
          "title": "Désactiver définitivement",
          "warn": "Cette action est IRRÉVERSIBLE.",
          "typeConfirm": "Tapez 'deactivate' pour confirmer",
          "description": "Confirmez la désactivation irréversible, le motif d'audit et la révocation des sessions."
        },
        "reactivate": "Réactiver",
        "resendInvite": "Renvoyer l'invitation"
      },
      "reason": {
        "label": "Raison (obligatoire)"
      },
      "activity": {
        "placeholder": "Le journal d'activité par membre sera disponible dans une vague ultérieure. Voir Paramètres → Activité pour le journal global du compte."
      },
      "create.success": "Invitation envoyée à {{email}}.",
      "update.success": "Membre mis à jour.",
      "suspend.success": "Membre suspendu.",
      "deactivate.success": "Membre désactivé.",
      "reactivate.success": "Membre réactivé.",
      "resendInvite.success": "Invitation renvoyée.",
      "detail": {
        "description": "Modifiez le profil du membre de l'équipe, le rôle, les limites de dépenses et les détails d'activité."
      }
    },
    "notifications": {
      "toggleAria": "{{cat}} {{ch}}"
    },
    "account": {
      "subtitle": "Gérez votre profil, votre sécurité, vos notifications et vos préférences",
      "title": "Paramètres du compte"
    },
    "pref": {
      "appearance": "Apparence",
      "communication": {
        "label": "Paramètres de communication",
        "sub": "Comment et quand nous vous envoyons des e-mails."
      },
      "currency": "Devise",
      "dashboardView": {
        "compact": "Compacte",
        "expanded": "Étendue (plus de détails)",
        "help": "Mode d'affichage par défaut des tableaux de données",
        "label": "Vue du dashboard par défaut"
      },
      "dateFormat": "Format de date",
      "display": {
        "label": "Paramètres d'affichage",
        "sub": "Apparence et disposition par défaut du dashboard."
      },
      "emailDigest": {
        "daily": "Quotidien",
        "help": "Résumé de l'activité envoyé à votre e-mail",
        "label": "Résumé par e-mail",
        "monthly": "Mensuel",
        "none": "Aucun",
        "weekly": "Résumé hebdomadaire"
      },
      "regional": {
        "label": "Paramètres régionaux",
        "sub": "Devise et format de date utilisés dans toute l'application."
      },
      "save": "Enregistrer les modifications"
    }
  },
  "branding": {
    "_comment": "Phase 6 Wave 11 Task 38 — Paramètres de marque (4 onglets) + journal des modifications. vg-binding: PLAN:task-38 / P6.D-100 / P6.D-101 / P6.D-105 / G-62 | Task 39 — gift-messages + thank-you-cards (P6.D-102 / P6.D-103 / G-64)",
    "title": "Marque",
    "openEditor": "Ouvrir l'éditeur complet",
    "tab": {
      "brandIdentity": "Identité de marque",
      "thankYouCards": "Cartes de remerciement",
      "thankYouCards.description": "Concevez la carte de remerciement imprimée glissée dans la commande. L'éditeur complet se trouve sur la page Cartes de remerciement.",
      "giftMessages": "Messages cadeau",
      "giftMessages.description": "Gérez les modèles de messages cadeau utilisables au moment du paiement. L'éditeur complet se trouve sur la page Messages cadeau.",
      "packaging": "Emballage"
    },
    "identity": {
      "title": "Identité de marque",
      "subtitle": "Logo, couleurs et slogan affichés sur les reçus, factures et emballages.",
      "brandName": "Nom de la marque",
      "logo": "Logo",
      "uploadLogo": "Téléverser le logo",
      "primaryColor": "Couleur principale",
      "secondaryColor": "Couleur secondaire",
      "fontFamily": "Police",
      "tagline": "Slogan",
      "taglinePlaceholder": "Slogan court pour reçus et emballages",
      "save": "Enregistrer",
      "preview": "Aperçu",
      "previewBadge": "Badge exemple"
    },
    "packaging": {
      "title": "Emballage par défaut",
      "description": "Sélectionnez l'emballage appliqué par défaut à toutes les commandes. Admin gère le catalogue.",
      "defaultLabel": "Par défaut",
      "setDefault": "Définir par défaut",
      "empty": "Aucune catégorie d'emballage disponible."
    },
    "changelog": {
      "title": "Modifications récentes",
      "empty": "Aucune modification pour l'instant.",
      "entry": "{{actor}} a modifié {{field}} de {{oldValue}} à {{newValue}}"
    },
    "giftMessages": {
      "title": "Messages cadeau",
      "create": "Créer",
      "submit": "Enregistrer",
      "preview": "Aperçu",
      "previewPlaceholder": "Votre message s'affichera ici.",
      "savedToast": "Message cadeau enregistré.",
      "empty": "Aucun modèle de message cadeau. Créez-en un pour le proposer au paiement.",
      "field": {
        "title": "Titre",
        "occasion": "Occasion",
        "message": "Message",
        "language": "Langue",
        "isDefault": "Par défaut",
        "charCounter": "{{count}} / {{max}}"
      },
      "occasion": {
        "birthday": "Anniversaire",
        "holiday": "Fête",
        "anniversary": "Anniversaire (couple)",
        "thankYou": "Remerciement",
        "custom": "Personnalisé"
      },
      "backToSettings": "Retour aux paramètres de marque",
      "edit": "Modifier le message cadeau",
      "editNotFound": "Message cadeau introuvable.",
      "noResults": "Aucun message cadeau ne correspond à votre recherche.",
      "resultsCount": "{{count}} résultats",
      "searchPlaceholder": "Rechercher des messages cadeaux…"
    },
    "thankYouCards": {
      "title": "Cartes de remerciement",
      "create": "Créer",
      "submit": "Enregistrer la carte",
      "preview": "Aperçu en direct",
      "previewPlaceholder": "Votre message apparaît ici.",
      "savedToast": "Carte enregistrée.",
      "empty": "Aucune carte. Créez-en une ou choisissez un modèle ci-dessous.",
      "imageHint": "PNG / JPG, ≤ 5 Mo",
      "field": {
        "title": "Titre",
        "header": "En-tête",
        "body": "Corps",
        "footer": "Pied",
        "fontFamily": "Police",
        "accentColor": "Couleur d'accent",
        "image": "Image (optionnelle)",
        "isDefault": "Par défaut"
      },
      "templates": {
        "title": "Partir d'un modèle",
        "useThis": "Utiliser ce modèle",
        "empty": "Aucun modèle disponible.",
        "prefilled": "Pré-rempli depuis un modèle."
      },
      "backToSettings": "Retour aux paramètres de marque",
      "edit": "Modifier la carte de remerciement",
      "editNotFound": "Carte de remerciement introuvable.",
      "imageTooLarge": "L'image ne doit pas dépasser 8 MB.",
      "noResults": "Aucune carte ne correspond à votre recherche.",
      "resultsCount": "{{count}} résultats",
      "searchPlaceholder": "Rechercher des cartes…"
    },
    "logoAlt": {
      "logo": "Logo de la marque",
      "preview": "Aperçu du logo de la marque"
    }
  },
  "notifications": {
    "_comment": "Phase 6 Wave 11 Task 38 — Préférences de notification (7 catégories × 3 canaux + son). Phase 6 Wave 12 Task 40 — étendu avec le Centre de notifications (6 onglets / liste groupée / état vide / paramètres / pastille temps réel). vg-binding: PLAN:task-38 / PLAN:task-40 / P6.D-06 / P6.D-118 / P6.D-119 / P6.D-120 / P6.D-121 / P6.D-174 / P6.D-225 / G-63 / G-65 / G-66",
    "title": "Préférences de notification",
    "save": "Enregistrer",
    "loadMore": "Charger plus",
    "unread": "Non lue",
    "nav": {
      "label": "Notifications"
    },
    "center": {
      "title": "Centre de notifications"
    },
    "settings": {
      "title": "Paramètres de notification",
      "category": {
        "orders": "Commandes",
        "shipping": "Livraison",
        "payment": "Paiement",
        "wallet": "Portefeuille",
        "billing": "Facturation",
        "system": "Annonces système",
        "marketing": "Marketing"
      }
    },
    "tab": {
      "all": "Tout",
      "orders": "Commandes",
      "products": "Produits",
      "stores": "Boutiques",
      "wallet": "Portefeuille",
      "system": "Système",
      "billing": "Facturation"
    },
    "filter": {
      "unreadOnly": "Non lues uniquement"
    },
    "bulk": {
      "markAllRead": "Tout marquer comme lu",
      "markAllReadError": "Impossible de tout marquer comme lu. Veuillez réessayer."
    },
    "item": {
      "viewDetail": "Voir le détail"
    },
    "empty": {
      "title": "Aucune notification pour le moment",
      "subtitle": "Vous verrez ici les nouveautés sur vos commandes, votre portefeuille ou vos boutiques."
    },
    "group": {
      "today": "Aujourd'hui",
      "yesterday": "Hier",
      "earlier": "Plus ancien"
    },
    "column": {
      "category": "Catégorie"
    },
    "category": {
      "orders": "Commandes",
      "shipping": "Livraison",
      "payment": "Paiement",
      "wallet": "Portefeuille",
      "billing": "Facturation",
      "system": "Annonces système",
      "marketing": "Marketing"
    },
    "channel": {
      "email": "Email",
      "push": "Push",
      "inApp": "Dans l'app"
    },
    "sound": {
      "label": "Son de notification dans l'app",
      "help": "Jouer un court signal lorsqu'une notification arrive.",
      "on": "Activé",
      "off": "Désactivé"
    },
    "detail": {
      "notFound": "Notification introuvable.",
      "back": "Retour aux notifications",
      "emptyBody": "Aucun contenu détaillé."
    }
  },
  "dashboard": {
    "_comment": "Phase 6 Wave 12 Task 41 — Dashboard surface (FR placeholder). vg-binding: PLAN:task-41 / P6.D-07..14 / G-67 / G-68",
    "title": "Tableau de bord",
    "kpi": {
      "todayRevenue": "Revenu du jour",
      "activeOrders": "Commandes en cours",
      "walletBalance": "Solde du portefeuille",
      "pendingTopups": "Recharges en attente",
      "deltaUp": "hausse",
      "deltaDown": "baisse"
    },
    "gettingStarted": {
      "title": "Démarrage rapide",
      "progress": "{{pct}} % terminé",
      "hideForever": "Masquer définitivement",
      "step": {
        "connectStore": "Connectez votre première boutique",
        "addProduct": "Ajoutez votre premier produit",
        "branding": "Configurer la marque",
        "setup2fa": "Activer la double authentification",
        "topupWallet": "Recharger le portefeuille",
        "inviteTeam": "Inviter un membre",
        "setupNotifications": "Configurer les notifications",
        "firstOrder": "Passer la première commande"
      }
    },
    "quickActions": {
      "title": "Actions rapides",
      "action": {
        "createOrder": "Créer une commande",
        "createOrder.subtext": "Nouvelle ou import",
        "connectStore": "Connecter une boutique",
        "connectStore.subtext": "Shopify, Woo, TikTok",
        "topupWallet": "Recharger",
        "topupWallet.subtext": "Approvisionner le portefeuille",
        "viewReports": "Voir les rapports",
        "viewReports.subtext": "Paiements & factures"
      }
    },
    "recentOrders": {
      "title": "Commandes récentes",
      "empty": "Aucune commande pour le moment.",
      "status": {
        "draft": "Brouillon",
        "pending": "En attente",
        "processing": "En cours",
        "shipped": "Expédiée",
        "delivered": "Livrée",
        "cancelled": "Annulée",
        "issues": "Problèmes"
      }
    },
    "topProducts": {
      "title": "Produits phares",
      "unitsSold": "unités",
      "empty": "Aucune vente sur les 30 derniers jours.",
      "viewAll": "Tout voir"
    },
    "activityFeed": {
      "title": "Activité récente",
      "empty": "Aucune activité récente."
    },
    "growth": {
      "placeholder": {
        "badge": "Données fictives",
        "title": "Insights de croissance bientôt",
        "cta": "GMV, niveau de fidélité et campagnes arriveront ici en Phase 10."
      }
    },
    "onboarding": {
      "welcome": {
        "title": "Bienvenue chez Printway",
        "subtitle": "Configuration en 5 étapes rapides."
      },
      "step": {
        "businessType": "Choisissez votre type d'activité",
        "connectStore": "Connectez votre première boutique",
        "addProduct": "Ajoutez votre premier produit",
        "done": "Tout est prêt"
      },
      "businessType": {
        "pod": "Print on Demand",
        "pod.subtext": "Vêtements, mugs et accessoires personnalisés.",
        "general": "Boutique générale",
        "general.subtext": "Catalogue de produits variés."
      },
      "connectStore": {
        "subtitle": "Connectez Shopify, WooCommerce ou TikTok Shop en un clic.",
        "cta": "Ouvrir le connecteur"
      },
      "addProduct": {
        "subtitle": "Parcourez le catalogue et créez votre premier produit.",
        "cta": "Ouvrir l'assistant produit"
      },
      "done": {
        "subtitle": "Tout est prêt — direction le tableau de bord."
      },
      "next": "Suivant",
      "back": "Retour",
      "skip": "Passer",
      "complete": "Aller au tableau de bord"
    },
    "subtitle": "Voici ce qui se passe pour votre activité d'impression à la demande.",
    "welcome": "Bon retour !",
    "welcomeNamed": "Bon retour, {{name}} !"
  },
  "myProducts": {
    "columns": {
      "thumbnail": "Image",
      "name": "Nom",
      "category": "Catégorie",
      "sync": "Sync",
      "created": "Créé",
      "lastModified": "Modifié",
      "actions": "Actions"
    },
    "delete": {
      "success": "\"{{name}}\" supprimé",
      "failed": "Échec de la suppression"
    }
  },
  "a11y": {
    "_comment": "Phase 6 i18n batch M3 — aria-label sweep. vg-binding: P6.D-131 / P6.D-221 / dbg-20260519-203958-merchant-i18n",
    "pagination": "Pagination",
    "firstPage": "Première page",
    "previousPage": "Page précédente",
    "nextPage": "Page suivante",
    "lastPage": "Dernière page",
    "openProfileMenu": "Ouvrir le menu du profil",
    "loadingPage": "Chargement de la page",
    "promoBanner": "Bannière promotionnelle",
    "dismissPromoBanner": "Fermer la bannière promotionnelle",
    "expandSidebar": "Ouvrir la barre latérale",
    "collapseSidebar": "Réduire la barre latérale",
    "dismissNotification": "Fermer la notification",
    "productEditorTabs": "Onglets de l’éditeur de produit",
    "close": "Fermer",
    "storeDisconnected": "Aucune boutique connectée",
    "storeSyncStatus": "Statut de synchronisation par boutique",
    "bulkActions": "Actions groupées",
    "moveUp": "Déplacer vers le haut",
    "moveDown": "Déplacer vers le bas",
    "remove": "Supprimer",
    "breadcrumb": "Fil d’Ariane",
    "primaryNavigation": "Navigation principale",
    "openNavigation": "Ouvrir la navigation",
    "artworkGrid": "Grille des visuels",
    "clear": "Effacer",
    "clearSearch": "Effacer la recherche",
    "removeLine": "Supprimer la ligne",
    "statementsChart": "Graphique des relevés",
    "spendingChart": "Graphique des dépenses",
    "range": "Période",
    "primaryColorHex": "Code hex couleur principale",
    "secondaryColorHex": "Code hex couleur secondaire",
    "onboardingProgress": "Progression de la configuration",
    "orderDetailSections": "Sections du détail de la commande",
    "public": "Public",
    "private": "Privé",
    "removeRule": "Supprimer la règle",
    "orderStatusTabs": "Onglets de statut de commande",
    "required": "Requis",
    "decreaseQuantity": "Diminuer la quantité",
    "increaseQuantity": "Augmenter la quantité",
    "decrease": "Diminuer",
    "increase": "Augmenter",
    "settingsSections": "Sections des paramètres",
    "teamMemberDetailTabs": "Onglets du membre d’équipe",
    "walletSubNavigation": "Sous-navigation du portefeuille",
    "instantGateways": "Passerelles instantanées",
    "selectAllRows": "Sélectionner toutes les lignes",
    "selectRow": "Sélectionner la ligne {{id}}",
    "skipToMain": "Aller au contenu principal",
    "backToTop": "Retour en haut",
    "openHelpMenu": "Ouvrir le menu d'aide"
  },
  "placeholder": {
    "_comment": "Phase 6 i18n batch M3 — placeholder sweep. vg-binding: P6.D-131 / P6.D-221 / dbg-20260519-203958-merchant-i18n",
    "url": "https://…",
    "productSlug": "mon-super-produit",
    "sku": "SKU…",
    "storeIds": "store_1, store_2",
    "categoryIds": "apparel, drinkware",
    "emailExample": "email@example.com",
    "expDate": "MM/AA",
    "cardHolderName": "Jean Dupont",
    "fnsku": "X00ABCDEFG",
    "countryCode": "FR",
    "skuPrefix": "SKU-",
    "timezone": "UTC",
    "shopifyDomain": "votre-boutique.myshopify.com",
    "shopUrl": "https://boutique.example.com",
    "merchantEmail": "marchand@example.com",
    "opsEmail": "ops@example.com"
  },
  "placeholders": {
    "_comment": "Phase 6 i18n batch M4 — PlaceholderPage stub titles. vg-binding: P6.D-131 / P6.D-221 / dbg-20260519-203958-merchant-i18n",
    "_fallback": {
      "title": "...",
      "description": "Espace réservé — la page réelle arrivera dans une wave ultérieure."
    },
    "dashboard": {
      "title": "Tableau de bord"
    },
    "artworkLibrary": {
      "title": "Bibliothèque de visuels"
    },
    "invoiceDetail": {
      "title": "Détail de la facture"
    },
    "invoices": {
      "title": "Factures"
    },
    "notifications": {
      "title": "Notifications"
    },
    "onboarding": {
      "title": "Mise en route"
    },
    "orderCreate": {
      "title": "Créer une commande"
    },
    "orderDetail": {
      "title": "Détail de la commande"
    },
    "orderImport": {
      "title": "Importer des commandes"
    },
    "orders": {
      "title": "Commandes"
    },
    "productCreate": {
      "title": "Créer un produit"
    },
    "productDetail": {
      "title": "Détail du produit"
    },
    "settingsBranding": {
      "title": "Image de marque"
    },
    "settingsProfile": {
      "title": "Profil"
    },
    "storeDetail": {
      "title": "Détail de la boutique"
    },
    "stores": {
      "title": "Paramètres de la boutique"
    },
    "storesSyncLogs": {
      "title": "Journaux de synchronisation"
    },
    "support": {
      "title": "Assistance"
    },
    "team": {
      "title": "Équipe"
    },
    "wallet": {
      "title": "Portefeuille"
    },
    "walletTopup": {
      "title": "Recharger le portefeuille"
    },
    "walletTransactions": {
      "title": "Transactions du portefeuille"
    }
  },
  "search": {
    "placeholder": "Rechercher…",
    "empty": "Aucun résultat",
    "moreHint": "+{{count}} de plus — saisir pour rechercher"
  },
  "profile": {
    "guest": "Invité",
    "account": "Compte",
    "notSignedIn": "Non connecté"
  },
  "breadcrumb": {
    "import": "Importer",
    "artwork": "Bibliothèque de visuels",
    "topup": "Recharger",
    "transactions": "Transactions",
    "onboarding": "Intégration",
    "login": "Connexion",
    "home": "Accueil",
    "detail": "Détails",
    "paymentMethods": "Moyens de paiement",
    "paymentRequests": "Demandes de paiement",
    "backToBilling": "← Retour à la facturation"
  },
  "bulkUpload": {
    "errorMalformedResponse": "Réponse de téléversement mal formée — consultez le journal réseau.",
    "errorHttpStatus": "Échec du téléversement (HTTP {{status}})",
    "dropPrompt": "Glissez un CSV ici, ou",
    "browseFile": "choisir un fichier",
    "selectedLabel": "Sélectionné :",
    "uploading": "Téléversement…",
    "upload": "Téléverser",
    "successCount": "{{n}} réussi(s)",
    "failureCount": "{{n}} en échec",
    "totalRows": "sur {{total}} lignes",
    "viewErrorDetails": "Voir les détails des erreurs ({{n}})",
    "rowLabel": "Ligne {{row_num}}"
  },
  "timezone": {
    "autoDetect": "Détection automatique ({{tz}})"
  },
  "badge": {
    "featured": "En vedette"
  },
  "common": {
    "cancel": "Annuler",
    "close": "Fermer",
    "loading": "Chargement…",
    "pagination": {
      "pageOf": "Page {{page}} sur {{total}}"
    }
  },
  "detail": {
    "blueprint": "Blueprint",
    "metaDescription": "Méta-description",
    "metaTitle": "Méta-titre",
    "seo": "SEO",
    "size": "Taille",
    "edit": "Modifier",
    "media": "Médias",
    "noImage": "Aucune image",
    "primary": "Principale",
    "general": "Général",
    "category": "Catégorie",
    "blueprintVersion": "Version du blueprint",
    "createdAt": "Créé le",
    "updatedAt": "Mis à jour le",
    "tags": "Étiquettes",
    "variants": "Variantes",
    "color": "Couleur",
    "priceOverride": "Prix personnalisé",
    "inventory": "Stock",
    "state": "État",
    "retired": "Retiré",
    "activeVariant": "Actif",
    "pricingPerStore": "Tarification par boutique",
    "store": "Boutique",
    "sellingPrice": "Prix de vente",
    "baseCost": "Coût de base (système → marchand)"
  },
  "help": {
    "announcements": "Annonces",
    "contact": "Contacter le support",
    "docs": "Documentation"
  },
  "notif": {
    "email": {
      "master": "Activer les notifications par e-mail",
      "test": "Tester",
      "testSent": "Envoyé",
      "title": "Notifications par e-mail"
    },
    "inApp": {
      "days": "{{count}} jours",
      "retention": "Conserver les notifications pendant :",
      "sound": "Activer les sons de notification",
      "soundHelp": "Jouer un bref carillon à l'arrivée d'une nouvelle notification.",
      "title": "Notifications dans l'application"
    },
    "notVerified": "Non vérifié",
    "push": {
      "blocked": "Bloqué",
      "deniedHelp": "Le push est bloqué dans les paramètres de votre navigateur. Réactivez-le d'abord là-bas.",
      "enabled": "Activé",
      "help": "Afficher les alertes bureau même lorsque cet onglet est en arrière-plan.",
      "master": "Activer les notifications push du navigateur",
      "notRequested": "Non demandé",
      "title": "Notifications push",
      "unsupported": "Non pris en charge",
      "unsupportedHelp": "Votre navigateur ne prend pas en charge les notifications push.",
      "inactive": "Non activé sur cet appareil",
      "activeHelp": "Ce navigateur recevra les alertes de portefeuille même lorsque l'onglet est en arrière-plan.",
      "unconfigured": "Les notifications push ne sont pas encore configurées sur ce serveur.",
      "error": "Impossible de mettre à jour les notifications push. Veuillez réessayer.",
      "working": "Mise à jour…"
    },
    "quiet": {
      "end": "Fin",
      "master": "Activer les heures de silence (aucune notification pendant cette période)",
      "start": "Début",
      "title": "Heures de silence"
    },
    "sms": {
      "codeLabel": "Saisissez le code à 6 chiffres que nous vous avons envoyé",
      "help": "Vérifiez votre numéro de téléphone pour recevoir des notifications par SMS.",
      "invalidCode": "Code invalide.",
      "master": "Activer les notifications par SMS",
      "title": "Notifications par SMS",
      "verifyCode": "Vérifier",
      "verifyPhone": "Vérifier le téléphone"
    },
    "verified": "Vérifié"
  },
  "pagination": {
    "of": "sur",
    "rowsPerPage": "Lignes par page",
    "showing": "Affichage"
  },
  "shipments": {
    "trackRouting": {
      "alerts": {
        "ageDays": "+{{days}} jours",
        "collapse": "Réduire les alertes",
        "empty": "Aucune alerte.",
        "expand": "Développer les alertes",
        "openExternal": "Ouvrir les détails",
        "summary": "{{critical}} critiques, {{warnings}} avertissements",
        "title": "Alertes d'expédition",
        "view": "Voir"
      },
      "cards": {
        "on_time_rate": {
          "sub": "{{numerator}} / {{denominator}} expéditions"
        },
        "active_time": {
          "label": "Temps actif",
          "sub": "{{count}} expéditions · moy {{avgHrs}} · max {{maxHrs}}"
        },
        "last_mile_time": {
          "label": "Temps du dernier kilomètre",
          "sub": "{{count}} expéditions · moy {{avgHrs}} · max {{maxHrs}}"
        }
      },
      "dashboardTitle": "Dashboard de performance SLA",
      "pagination": {
        "next": "Page suivante",
        "prev": "Page précédente",
        "show": "Afficher",
        "total": "Total : {{total}}"
      },
      "statusOverview": {
        "title": "Aperçu du statut des expéditions"
      },
      "subtitle": "Surveillez la performance SLA et suivez toutes les expéditions",
      "table": {
        "columns": {
          "firstScan": "Premier scan",
          "delivered": "Livré"
        },
        "delayDays": "+{{days}} jours de retard",
        "deliveredPrefix": "Livré",
        "empty": "Aucune expédition ne correspond au filtre actif.",
        "openExternal": "Ouvrir le lien de suivi",
        "slaDays": "{{days}} j",
        "viewAction": "Voir les détails",
        "notShipped": "—"
      },
      "title": "Suivi du routage",
      "toolbar": {
        "allCarriers": "Tous les transporteurs",
        "allStatuses": "Tous les statuts",
        "searchPlaceholder": "Rechercher par numéro de suivi ou commande…"
      },
      "window": {
        "7d": "7 jours",
        "30d": "30 jours",
        "90d": "90 jours",
        "aria": "Fenêtre des métriques SLA"
      },
      "dashboardEmpty": "Aucune donnée sur cette période",
      "emptyBanner": {
        "title": "Aucune donnée de suivi SLA pour le moment",
        "description": "Les métriques de délai SLA apparaîtront dès que les transporteurs signalent des scans de colis pour les expéditions de cette période."
      }
    }
  },
  "sidebar": {
    "categories": "Catégories",
    "filters": "Filtres",
    "max": "Max",
    "min": "Min",
    "priceRange": "Plage de prix"
  },
  "twoFA": {
    "challengeSubtitle": "Saisissez le code à 6 chiffres de votre application d'authentification pour autoriser cette action.",
    "challengeTitle": "Confirmer avec l'authentification à deux facteurs",
    "code": "Code à 6 chiffres",
    "codeFormat": "Saisissez le code à 6 chiffres de votre application d'authentification.",
    "codeLabel": "Code à 6 chiffres",
    "confirm": "Confirmer",
    "error": "Code invalide",
    "errorLength": "Le code doit comporter exactement 6 chiffres",
    "locked": "2FA temporairement verrouillée après trop d'échecs. Réessayez plus tard.",
    "title": "Vérification 2FA",
    "verify": "Vérifier",
    "notEnrolledTitle": "2FA non activé",
    "notEnrolledDesc": "Les retraits nécessitent l'authentification à deux facteurs. Veuillez d'abord activer la 2FA.",
    "goToSetup": "Aller aux paramètres de sécurité →"
  },
  "wizard": {
    "breadcrumbEdit": "Mes produits / Modifier le produit",
    "pageTitleEdit": "Modifier le produit",
    "step2": {
      "col": {
        "customSku": "SKU personnalisé"
      },
      "customSkuHint": "Facultatif. Laissez vide pour réutiliser le SKU du système lors de la correspondance des commandes.",
      "customSkuDup": "SKU personnalisé en double — il doit être unique dans le produit."
    },
    "step3": {
      "libraryEmpty": "Votre bibliothèque est vide.",
      "libraryEmptyHint": "Téléversez un fichier via la zone de glisser-déposer ci-dessous — il apparaîtra ici la prochaine fois.",
      "libraryLoadFailed": "Impossible de charger votre bibliothèque. Réessayez.",
      "libraryTitle": "Choisir dans la bibliothèque"
    },
    "step5": {
      "cards": {
        "mainMissing": "non sélectionnée",
        "mainSet": "sélectionnée",
        "mockup": "Mockup",
        "mockupCount": "{{count}} image(s) · image principale {{main}}",
        "mockupEmpty": "Aucune image téléversée"
      }
    },
    "nav": {
      "saving": "Enregistrement…",
      "saveChanges": "Enregistrer les modifications"
    }
  },
  "mode": "édition",
  "step": "variantes",
  "retry": "1",
  "read": "non lu",
  "limit": "20",
  "editor": {
    "actions": {
      "saved": "Produit enregistré",
      "saveFailed": "Échec de l'enregistrement",
      "noChanges": "Aucune modification à enregistrer"
    }
  },
  "info": "Artwork déplacé vers {{folder}}",
  "error": "Impossible de déplacer l'artwork. Veuillez réessayer."
}
